/**
 * Özel Ölçü — Amorf Şekil Motoru v1.0
 * ozel-olcu-plus.js ile entegre çalışır.
 * Shopify theme asset: assets/ozel-olcu-amorf.js
 *
 * API:
 *   window.__OzelOlcuAmorf.init(container, config)
 *   window.__OzelOlcuAmorf.getShape() → {radii, contour, area, perimeter}
 *   window.__OzelOlcuAmorf.renderPreview(fabricImg, canvas) → giydirme
 */
(function() {
  'use strict';

  // ═══ SABITLER ═══
  var N = 60;           // Kontrol noktası sayısı (gizli)
  var MIN_R = 0.52;     // Minimum radius (derin girinti engeli)
  var MAX_R = 0.98;     // Maksimum radius
  var TENSION = 0.28;   // Bezier yumuşaklık

  // Her preset icin dogal aspect ratio (genislik/yukseklik). Build-time hesaplanmis.
  var _PRESET_ASPECT = {
    'Organik':1.009,'Damla':1.558,'Nehir Tasi':1.113,'Ruzgar':0.813,'Cakil':0.914,
    'Gol':1.073,'Yaprak':0.886,'Bulut':1.223,'Mercan':0.969,'Gozyasi':1.482,
    'Firtina':0.98,'Dalga':0.89,'Tomurcuk':1.147,'Akarsu':1.058,'Mantar':1.154,
    'Deniz Kabugu':1.271,'Lale':1.061,'Tas':1.093,'Kanat':0.691,'Kaya':1.284,
    'Ada':0.825,'Ayna':0.918,'Orkide':1.349,'Badem':1.356,'Kapadokya':0.789,
    'Peri Bacasi':0.822,'Lagun':1.02,'Ege':0.814,'Yonca':0.887,'Volkan':1.301,
    'Ipek Yolu':0.749,'Akdeniz':0.735,'Sutun':1.618,'Oasis':0.949,'Sahil':1.002,
    'Vadi':1.014,'Hilal':1.047,'Nehir':0.687,'Kugu':0.778,'Gece':1.024,
    'Safak':0.95,'Nilufer':1.457,'Gelgit':1.047,'Ruya':0.602,'Anadolu':1.108,
    'Yosun':1.113,'Fasulye':1.457,'Aurora':1.097,'Lotus':1.503,'Bosphorus':0.702,
    'Kalp':1.110,'Koc \u2648':1.083,'Aslan \u264C':1.037,'Yay \u2650':0.953,
    'Boga \u2649':0.674,'Basak \u264D':1.66,'Oglak \u2651':0.942,
    'Ikizler \u264A':0.609,'Terazi \u264E':1,'Kova \u2652':0.969,
    'Yengec \u264B':0.979,'Akrep \u264F':1.081,'Balik \u2653':0.738
  };

  var DRAG_SPREAD = 4;  // Sürükleme etki alanı
  var PREVIEW_BG_BRIGHTNESS = 245;
  var PREVIEW_BIYE_DEPTH_PX = 28;
  var PREVIEW_BORDUR_DEPTH_PX = 85;
  var PREVIEW_POST_CONTRAST = 1.06;
  var PREVIEW_POST_SATURATE = 1.10;

  // ═══ PRESET ŞEKİLLER ═══
  var PRESETS = [
    {l:'Organik',g:['#4ade80','#15803d'],r:[0.794,0.803,0.815,0.834,0.859,0.891,0.928,0.960,0.980,0.975,0.939,0.878,0.805,0.734,0.673,0.626,0.589,0.562,0.541,0.528,0.521,0.520,0.525,0.536,0.553,0.577,0.610,0.650,0.695,0.740,0.778,0.802,0.808,0.799,0.780,0.757,0.735,0.718,0.707,0.701,0.700,0.703,0.711,0.724,0.740,0.760,0.785,0.813,0.838,0.858,0.868,0.869,0.862,0.849,0.833,0.819,0.808,0.799,0.794,0.793],e:{o:1,b:1,d:1}},
    {l:'Damla',g:['#94a3b8','#334155'],r:[0.536,0.522,0.520,0.533,0.560,0.588,0.615,0.638,0.660,0.683,0.715,0.762,0.822,0.882,0.930,0.961,0.970,0.962,0.944,0.925,0.916,0.913,0.906,0.887,0.848,0.790,0.718,0.640,0.579,0.546,0.536,0.544,0.569,0.610,0.664,0.734,0.808,0.877,0.931,0.964,0.979,0.980,0.977,0.976,0.973,0.961,0.937,0.903,0.865,0.829,0.797,0.765,0.729,0.691,0.653,0.621,0.600,0.583,0.567,0.550],e:{o:1,b:1,d:1}},
    {l:'Nehir Tasi',g:['#c084fc','#7e22ce'],r:[0.804,0.796,0.789,0.785,0.783,0.786,0.792,0.801,0.812,0.822,0.833,0.844,0.856,0.871,0.890,0.911,0.932,0.951,0.965,0.974,0.978,0.978,0.979,0.980,0.978,0.967,0.940,0.893,0.827,0.747,0.666,0.604,0.560,0.533,0.520,0.522,0.538,0.569,0.617,0.683,0.756,0.820,0.868,0.900,0.916,0.921,0.923,0.925,0.927,0.928,0.926,0.917,0.904,0.887,0.868,0.850,0.835,0.825,0.816,0.809],e:{o:1,b:1,d:1}},
    {l:'Ruzgar',g:['#fbbf24','#ea580c'],r:[0.784,0.756,0.727,0.691,0.652,0.612,0.582,0.564,0.556,0.556,0.560,0.568,0.578,0.589,0.603,0.618,0.629,0.631,0.621,0.596,0.561,0.534,0.520,0.520,0.533,0.557,0.594,0.640,0.682,0.721,0.759,0.799,0.846,0.901,0.952,0.980,0.979,0.949,0.895,0.829,0.763,0.708,0.665,0.635,0.620,0.620,0.635,0.668,0.720,0.781,0.837,0.879,0.904,0.908,0.896,0.873,0.847,0.826,0.810,0.795],e:{o:1,b:1,d:1}},
    {l:'Cakil',g:['#60a5fa','#1e40af'],r:[0.856,0.887,0.913,0.939,0.961,0.975,0.980,0.976,0.965,0.950,0.934,0.910,0.876,0.827,0.765,0.693,0.620,0.567,0.535,0.520,0.523,0.543,0.582,0.642,0.726,0.818,0.890,0.927,0.919,0.875,0.812,0.752,0.708,0.680,0.667,0.666,0.679,0.706,0.745,0.787,0.820,0.838,0.838,0.823,0.798,0.771,0.747,0.723,0.697,0.667,0.635,0.605,0.589,0.586,0.597,0.622,0.661,0.717,0.772,0.819],e:{o:1,b:1,d:1}},
    {l:'Gol',g:['#f472b6','#be185d'],r:[0.767,0.730,0.688,0.643,0.595,0.557,0.533,0.521,0.520,0.530,0.551,0.586,0.634,0.682,0.729,0.775,0.821,0.869,0.919,0.960,0.980,0.974,0.946,0.903,0.863,0.833,0.812,0.798,0.792,0.794,0.801,0.805,0.804,0.797,0.783,0.766,0.747,0.733,0.725,0.723,0.727,0.738,0.756,0.782,0.811,0.838,0.861,0.879,0.895,0.909,0.922,0.936,0.945,0.946,0.936,0.917,0.890,0.859,0.829,0.798],e:{o:1,b:1,d:1}},
    {l:'Yaprak',g:['#fb923c','#c2410c'],r:[0.833,0.801,0.758,0.704,0.645,0.595,0.559,0.535,0.522,0.520,0.528,0.546,0.575,0.607,0.640,0.674,0.710,0.750,0.796,0.849,0.903,0.947,0.974,0.980,0.969,0.945,0.918,0.893,0.871,0.852,0.834,0.818,0.805,0.794,0.786,0.780,0.773,0.764,0.753,0.741,0.728,0.717,0.710,0.707,0.709,0.714,0.724,0.738,0.757,0.782,0.812,0.840,0.863,0.878,0.885,0.884,0.878,0.871,0.863,0.851],e:{o:1,b:1,d:1}},
    {l:'Bulut',g:['#f87171','#b91c1c'],r:[0.669,0.656,0.651,0.652,0.659,0.667,0.679,0.693,0.712,0.735,0.765,0.802,0.844,0.880,0.896,0.880,0.832,0.762,0.690,0.632,0.589,0.558,0.536,0.524,0.520,0.524,0.536,0.556,0.580,0.606,0.633,0.665,0.700,0.741,0.788,0.844,0.900,0.945,0.973,0.980,0.970,0.949,0.926,0.908,0.897,0.891,0.890,0.894,0.902,0.916,0.932,0.942,0.941,0.923,0.888,0.840,0.788,0.744,0.710,0.685],e:{o:1,b:1,d:1}},
    {l:'Mercan',g:['#2dd4bf','#0f766e'],r:[0.889,0.815,0.733,0.651,0.593,0.554,0.530,0.520,0.522,0.536,0.565,0.612,0.672,0.729,0.781,0.825,0.865,0.901,0.937,0.966,0.980,0.973,0.944,0.900,0.854,0.821,0.802,0.796,0.802,0.820,0.853,0.899,0.937,0.951,0.928,0.871,0.798,0.739,0.700,0.679,0.672,0.679,0.702,0.741,0.796,0.845,0.881,0.900,0.906,0.903,0.896,0.891,0.889,0.889,0.893,0.899,0.909,0.922,0.927,0.916],e:{o:1,b:1,d:1}},
    {l:'Gozyasi',g:['#a78bfa','#5b21b6'],r:[0.560,0.546,0.537,0.529,0.524,0.521,0.520,0.522,0.527,0.537,0.552,0.573,0.602,0.640,0.688,0.749,0.820,0.891,0.949,0.980,0.974,0.935,0.876,0.809,0.745,0.691,0.647,0.614,0.589,0.573,0.565,0.564,0.571,0.585,0.608,0.640,0.680,0.727,0.775,0.819,0.853,0.875,0.884,0.881,0.872,0.860,0.850,0.846,0.843,0.840,0.833,0.819,0.796,0.763,0.725,0.683,0.645,0.616,0.592,0.573],e:{o:1,b:1,d:1}},
    {l:'Firtina',g:['#4ade80','#15803d'],r:[0.795,0.858,0.864,0.834,0.787,0.741,0.705,0.679,0.662,0.652,0.648,0.651,0.659,0.673,0.693,0.721,0.757,0.802,0.860,0.923,0.967,0.980,0.965,0.932,0.901,0.877,0.861,0.852,0.850,0.853,0.856,0.849,0.832,0.803,0.766,0.728,0.700,0.684,0.676,0.677,0.687,0.707,0.737,0.777,0.813,0.832,0.818,0.769,0.698,0.629,0.580,0.548,0.529,0.520,0.522,0.533,0.555,0.591,0.646,0.725],e:{o:1,b:1,d:1}},
    {l:'Dalga',g:['#94a3b8','#334155'],r:[0.968,0.973,0.960,0.933,0.898,0.866,0.843,0.827,0.820,0.819,0.825,0.838,0.854,0.864,0.867,0.858,0.840,0.816,0.788,0.766,0.752,0.747,0.751,0.765,0.790,0.827,0.878,0.931,0.970,0.980,0.951,0.886,0.798,0.705,0.633,0.580,0.544,0.525,0.520,0.530,0.555,0.595,0.654,0.726,0.792,0.843,0.871,0.876,0.863,0.839,0.815,0.799,0.793,0.794,0.804,0.820,0.845,0.877,0.915,0.947],e:{o:1,b:1,d:1}},
    {l:'Tomurcuk',g:['#c084fc','#7e22ce'],r:[0.701,0.683,0.682,0.692,0.713,0.735,0.753,0.764,0.767,0.765,0.759,0.757,0.761,0.773,0.794,0.824,0.864,0.912,0.946,0.950,0.913,0.838,0.738,0.646,0.582,0.541,0.521,0.520,0.538,0.577,0.638,0.706,0.761,0.796,0.805,0.793,0.767,0.737,0.716,0.705,0.704,0.712,0.729,0.757,0.794,0.837,0.875,0.908,0.933,0.950,0.963,0.973,0.980,0.977,0.960,0.926,0.875,0.815,0.760,0.721],e:{o:1,b:1,d:1}},
    {l:'Akarsu',g:['#fbbf24','#ea580c'],r:[0.625,0.663,0.701,0.744,0.793,0.852,0.914,0.963,0.980,0.957,0.902,0.829,0.765,0.717,0.682,0.660,0.647,0.645,0.652,0.669,0.686,0.700,0.708,0.711,0.709,0.705,0.701,0.697,0.694,0.692,0.690,0.690,0.692,0.697,0.704,0.710,0.715,0.719,0.721,0.723,0.727,0.732,0.737,0.740,0.735,0.721,0.697,0.664,0.627,0.591,0.562,0.542,0.528,0.521,0.520,0.525,0.536,0.553,0.576,0.601],e:{o:1,b:1,d:1}},
    {l:'Mantar',g:['#60a5fa','#1e40af'],r:[0.686,0.674,0.672,0.678,0.697,0.729,0.766,0.800,0.823,0.832,0.826,0.808,0.784,0.761,0.745,0.742,0.748,0.757,0.762,0.760,0.748,0.727,0.700,0.672,0.650,0.639,0.642,0.654,0.669,0.681,0.684,0.675,0.653,0.621,0.586,0.552,0.528,0.520,0.525,0.540,0.561,0.586,0.614,0.644,0.679,0.719,0.770,0.829,0.889,0.940,0.973,0.980,0.961,0.922,0.870,0.816,0.772,0.739,0.714,0.695],e:{o:1,b:1,d:1}},
    {l:'Deniz Kabugu',g:['#f472b6','#be185d'],r:[0.559,0.557,0.567,0.588,0.621,0.666,0.720,0.770,0.809,0.832,0.835,0.821,0.797,0.769,0.744,0.723,0.706,0.690,0.674,0.658,0.641,0.624,0.608,0.596,0.587,0.580,0.575,0.570,0.567,0.565,0.565,0.568,0.570,0.570,0.567,0.560,0.551,0.540,0.530,0.522,0.520,0.524,0.535,0.554,0.582,0.620,0.669,0.731,0.808,0.887,0.950,0.980,0.966,0.913,0.838,0.757,0.688,0.635,0.597,0.572],e:{o:1,b:1,d:1}},
    {l:'Lale',g:['#fb923c','#c2410c'],r:[0.758,0.761,0.752,0.738,0.722,0.709,0.701,0.699,0.702,0.707,0.714,0.721,0.729,0.737,0.746,0.758,0.774,0.794,0.817,0.838,0.854,0.861,0.858,0.845,0.824,0.801,0.779,0.765,0.757,0.755,0.759,0.768,0.782,0.803,0.830,0.865,0.906,0.944,0.972,0.980,0.962,0.919,0.859,0.791,0.723,0.667,0.620,0.583,0.554,0.534,0.523,0.520,0.525,0.540,0.564,0.598,0.639,0.680,0.716,0.744],e:{o:1,b:1,d:1}},
    {l:'Tas',g:['#f87171','#b91c1c'],r:[0.672,0.678,0.697,0.729,0.772,0.831,0.898,0.953,0.980,0.969,0.924,0.855,0.783,0.723,0.675,0.636,0.605,0.579,0.558,0.539,0.526,0.520,0.521,0.529,0.544,0.569,0.602,0.636,0.661,0.672,0.670,0.656,0.634,0.610,0.591,0.577,0.567,0.563,0.565,0.573,0.588,0.610,0.634,0.658,0.681,0.701,0.721,0.742,0.764,0.790,0.817,0.840,0.853,0.850,0.832,0.801,0.761,0.721,0.692,0.676],e:{o:1,b:1,d:1}},
    {l:'Kanat',g:['#2dd4bf','#0f766e'],r:[0.860,0.854,0.845,0.836,0.829,0.820,0.807,0.787,0.760,0.727,0.692,0.658,0.627,0.603,0.587,0.577,0.577,0.585,0.603,0.632,0.673,0.728,0.797,0.869,0.930,0.971,0.980,0.957,0.909,0.847,0.783,0.727,0.683,0.647,0.620,0.597,0.579,0.563,0.549,0.536,0.525,0.520,0.522,0.531,0.546,0.565,0.589,0.616,0.646,0.681,0.716,0.748,0.776,0.797,0.813,0.826,0.837,0.849,0.857,0.861],e:{o:1,b:1,d:1}},
    {l:'Kaya',g:['#a78bfa','#5b21b6'],r:[0.575,0.546,0.530,0.522,0.520,0.526,0.541,0.564,0.598,0.644,0.704,0.781,0.856,0.908,0.918,0.886,0.825,0.756,0.699,0.653,0.617,0.589,0.568,0.552,0.541,0.536,0.537,0.544,0.558,0.578,0.606,0.642,0.678,0.712,0.746,0.780,0.816,0.854,0.891,0.921,0.938,0.943,0.938,0.926,0.915,0.909,0.908,0.912,0.922,0.937,0.958,0.977,0.980,0.960,0.913,0.845,0.766,0.697,0.643,0.601],e:{o:1,b:1,d:1}},
    {l:'Ada',g:['#4ade80','#15803d'],r:[0.880,0.851,0.799,0.732,0.661,0.598,0.550,0.526,0.520,0.531,0.552,0.579,0.608,0.635,0.658,0.678,0.696,0.716,0.749,0.796,0.851,0.905,0.949,0.976,0.980,0.964,0.933,0.905,0.889,0.881,0.879,0.881,0.886,0.894,0.908,0.927,0.936,0.930,0.907,0.870,0.824,0.777,0.738,0.712,0.695,0.677,0.655,0.627,0.596,0.565,0.539,0.522,0.520,0.536,0.575,0.635,0.705,0.776,0.835,0.872],e:{o:1,b:1,d:1}},
    {l:'Ayna',g:['#94a3b8','#334155'],r:[0.712,0.651,0.604,0.569,0.545,0.532,0.528,0.534,0.549,0.575,0.606,0.634,0.658,0.678,0.694,0.708,0.722,0.737,0.752,0.767,0.780,0.792,0.803,0.815,0.828,0.840,0.842,0.831,0.802,0.758,0.703,0.647,0.603,0.570,0.547,0.531,0.522,0.520,0.523,0.531,0.543,0.559,0.579,0.603,0.631,0.663,0.698,0.734,0.773,0.816,0.864,0.917,0.960,0.980,0.970,0.935,0.886,0.837,0.791,0.745],e:{o:1,b:1,d:1}},
    {l:'Orkide',g:['#c084fc','#7e22ce'],r:[0.590,0.573,0.559,0.546,0.533,0.524,0.520,0.525,0.538,0.556,0.578,0.604,0.633,0.666,0.703,0.747,0.799,0.857,0.913,0.958,0.980,0.975,0.942,0.889,0.824,0.760,0.706,0.662,0.628,0.602,0.583,0.571,0.566,0.568,0.579,0.599,0.622,0.645,0.665,0.680,0.691,0.700,0.709,0.722,0.742,0.772,0.809,0.845,0.873,0.887,0.882,0.858,0.820,0.773,0.725,0.683,0.651,0.628,0.611,0.597],e:{o:1,b:1,d:1}},
    {l:'Badem',g:['#fbbf24','#ea580c'],r:[0.642,0.633,0.622,0.610,0.600,0.595,0.597,0.605,0.620,0.644,0.676,0.717,0.771,0.833,0.885,0.910,0.897,0.847,0.777,0.707,0.650,0.606,0.573,0.549,0.533,0.523,0.520,0.522,0.529,0.542,0.561,0.588,0.623,0.669,0.727,0.799,0.872,0.930,0.966,0.980,0.978,0.967,0.953,0.937,0.916,0.887,0.849,0.806,0.759,0.719,0.687,0.663,0.645,0.634,0.628,0.628,0.633,0.639,0.644,0.644],e:{o:1,b:1,d:1}},
    {l:'Kapadokya',g:['#60a5fa','#1e40af'],r:[0.840,0.846,0.854,0.863,0.876,0.888,0.892,0.879,0.842,0.781,0.704,0.627,0.572,0.539,0.522,0.520,0.533,0.561,0.608,0.678,0.774,0.871,0.944,0.979,0.980,0.957,0.925,0.895,0.870,0.847,0.827,0.808,0.791,0.775,0.761,0.749,0.736,0.722,0.705,0.685,0.663,0.640,0.621,0.609,0.605,0.607,0.615,0.632,0.656,0.688,0.728,0.765,0.797,0.819,0.831,0.835,0.834,0.832,0.833,0.836],e:{o:1,b:1,d:1}},
    {l:'Peri Bacasi',g:['#f472b6','#be185d'],r:[0.766,0.803,0.835,0.871,0.912,0.953,0.980,0.979,0.944,0.877,0.792,0.710,0.652,0.614,0.594,0.591,0.604,0.634,0.684,0.738,0.786,0.826,0.859,0.887,0.911,0.927,0.921,0.883,0.812,0.716,0.627,0.569,0.534,0.520,0.526,0.551,0.599,0.666,0.724,0.757,0.758,0.730,0.684,0.638,0.601,0.574,0.556,0.547,0.546,0.554,0.570,0.587,0.605,0.621,0.638,0.654,0.673,0.694,0.719,0.745],e:{o:1,b:1,d:1}},
    {l:'Lagun',g:['#fb923c','#c2410c'],r:[0.726,0.720,0.724,0.737,0.755,0.770,0.779,0.781,0.775,0.764,0.750,0.736,0.725,0.719,0.716,0.715,0.715,0.716,0.717,0.719,0.724,0.732,0.745,0.763,0.781,0.795,0.799,0.789,0.765,0.729,0.684,0.638,0.599,0.570,0.550,0.536,0.528,0.523,0.521,0.521,0.520,0.523,0.533,0.552,0.580,0.617,0.665,0.725,0.798,0.877,0.941,0.977,0.980,0.954,0.911,0.862,0.820,0.785,0.757,0.737],e:{o:1,b:1,d:1}},
    {l:'Ege',g:['#f87171','#b91c1c'],r:[0.812,0.816,0.818,0.822,0.828,0.831,0.825,0.805,0.768,0.717,0.656,0.597,0.553,0.527,0.520,0.531,0.563,0.617,0.695,0.790,0.875,0.938,0.973,0.980,0.965,0.936,0.906,0.879,0.855,0.829,0.801,0.768,0.732,0.697,0.665,0.641,0.623,0.608,0.594,0.579,0.563,0.548,0.535,0.529,0.533,0.544,0.560,0.582,0.607,0.637,0.673,0.712,0.748,0.779,0.799,0.808,0.809,0.806,0.805,0.808],e:{o:1,b:1,d:1}},
    {l:'Yonca',g:['#2dd4bf','#0f766e'],r:[0.858,0.904,0.933,0.953,0.965,0.971,0.976,0.980,0.979,0.967,0.940,0.896,0.839,0.774,0.708,0.651,0.603,0.566,0.539,0.524,0.520,0.529,0.552,0.589,0.642,0.707,0.769,0.824,0.864,0.886,0.892,0.885,0.872,0.859,0.851,0.851,0.858,0.869,0.879,0.883,0.877,0.856,0.823,0.778,0.729,0.680,0.636,0.604,0.584,0.575,0.575,0.584,0.599,0.620,0.646,0.675,0.707,0.742,0.782,0.825],e:{o:1,b:1,d:1}},
    {l:'Volkan',g:['#a78bfa','#5b21b6'],r:[0.708,0.688,0.656,0.620,0.587,0.564,0.552,0.549,0.555,0.571,0.597,0.635,0.685,0.751,0.825,0.892,0.942,0.970,0.980,0.977,0.967,0.956,0.944,0.927,0.900,0.862,0.815,0.762,0.717,0.683,0.658,0.642,0.632,0.628,0.630,0.636,0.648,0.666,0.692,0.727,0.773,0.833,0.898,0.945,0.949,0.899,0.810,0.713,0.639,0.587,0.552,0.530,0.520,0.522,0.536,0.562,0.602,0.646,0.683,0.704],e:{o:1,b:1,d:1}},
    {l:'Ipek Yolu',g:['#4ade80','#15803d'],r:[0.835,0.830,0.808,0.768,0.716,0.663,0.622,0.592,0.571,0.558,0.553,0.553,0.559,0.569,0.581,0.597,0.615,0.637,0.663,0.691,0.725,0.766,0.815,0.876,0.943,0.980,0.954,0.853,0.720,0.628,0.570,0.536,0.520,0.520,0.537,0.573,0.628,0.687,0.733,0.752,0.742,0.709,0.665,0.626,0.597,0.577,0.565,0.562,0.567,0.580,0.602,0.632,0.664,0.694,0.722,0.747,0.769,0.788,0.808,0.825],e:{o:1,b:1,d:1}},
    {l:'Akdeniz',g:['#94a3b8','#334155'],r:[0.903,0.950,0.964,0.955,0.934,0.913,0.893,0.871,0.848,0.824,0.799,0.772,0.740,0.704,0.663,0.621,0.588,0.570,0.566,0.578,0.605,0.649,0.713,0.795,0.873,0.933,0.969,0.980,0.971,0.951,0.928,0.903,0.872,0.834,0.787,0.732,0.673,0.615,0.571,0.541,0.525,0.520,0.527,0.546,0.576,0.619,0.666,0.703,0.723,0.723,0.703,0.669,0.633,0.612,0.607,0.619,0.648,0.694,0.760,0.842],e:{o:1,b:1,d:1}},
    {l:'Sutun',g:['#c084fc','#7e22ce'],r:[0.547,0.557,0.571,0.592,0.621,0.654,0.688,0.720,0.751,0.782,0.813,0.847,0.884,0.921,0.950,0.969,0.975,0.970,0.957,0.940,0.922,0.899,0.867,0.822,0.764,0.695,0.627,0.577,0.543,0.525,0.520,0.528,0.549,0.585,0.638,0.711,0.783,0.844,0.890,0.921,0.942,0.958,0.971,0.980,0.979,0.963,0.931,0.886,0.832,0.780,0.736,0.699,0.667,0.640,0.615,0.594,0.575,0.559,0.550,0.546],e:{o:1,b:1,d:1}},
    {l:'Oasis',g:['#fbbf24','#ea580c'],r:[0.815,0.798,0.783,0.770,0.760,0.751,0.744,0.740,0.737,0.736,0.738,0.744,0.754,0.767,0.780,0.787,0.784,0.766,0.734,0.691,0.643,0.598,0.563,0.540,0.525,0.520,0.523,0.535,0.557,0.588,0.632,0.691,0.769,0.858,0.935,0.979,0.980,0.946,0.895,0.841,0.799,0.769,0.750,0.741,0.741,0.751,0.770,0.800,0.842,0.890,0.933,0.963,0.974,0.967,0.947,0.920,0.894,0.871,0.850,0.832],e:{o:1,b:1,d:1}},
    {l:'Sahil',g:['#60a5fa','#1e40af'],r:[0.794,0.788,0.789,0.794,0.804,0.818,0.835,0.849,0.857,0.858,0.850,0.835,0.814,0.792,0.771,0.753,0.738,0.725,0.715,0.707,0.701,0.699,0.701,0.707,0.719,0.736,0.757,0.778,0.793,0.797,0.787,0.762,0.724,0.681,0.636,0.596,0.565,0.542,0.527,0.520,0.521,0.528,0.543,0.566,0.597,0.637,0.687,0.749,0.819,0.887,0.943,0.975,0.980,0.962,0.929,0.892,0.858,0.832,0.813,0.799],e:{o:1,b:1,d:1}},
    {l:'Vadi',g:['#f472b6','#be185d'],r:[0.886,0.907,0.924,0.942,0.961,0.974,0.980,0.978,0.969,0.955,0.940,0.929,0.920,0.913,0.909,0.909,0.912,0.918,0.923,0.927,0.930,0.931,0.934,0.938,0.943,0.946,0.944,0.936,0.923,0.907,0.889,0.870,0.848,0.817,0.775,0.723,0.662,0.600,0.555,0.530,0.520,0.526,0.548,0.588,0.650,0.743,0.852,0.935,0.971,0.960,0.920,0.872,0.836,0.813,0.800,0.798,0.805,0.823,0.846,0.868],e:{o:1,b:1,d:1}},
    {l:'Hilal',g:['#fb923c','#c2410c'],r:[0.684,0.728,0.752,0.764,0.768,0.768,0.766,0.765,0.763,0.758,0.748,0.735,0.718,0.705,0.702,0.707,0.721,0.745,0.781,0.831,0.896,0.953,0.980,0.965,0.916,0.856,0.808,0.773,0.750,0.737,0.733,0.737,0.750,0.774,0.800,0.821,0.836,0.841,0.840,0.833,0.823,0.814,0.803,0.788,0.766,0.736,0.698,0.656,0.612,0.577,0.551,0.534,0.523,0.520,0.523,0.532,0.549,0.573,0.608,0.651],e:{o:1,b:1,d:1}},
    {l:'Nehir',g:['#f87171','#b91c1c'],r:[0.884,0.868,0.841,0.805,0.768,0.735,0.707,0.685,0.666,0.650,0.637,0.625,0.615,0.606,0.600,0.600,0.605,0.616,0.634,0.659,0.692,0.736,0.790,0.857,0.924,0.971,0.980,0.943,0.876,0.799,0.731,0.676,0.633,0.599,0.573,0.553,0.538,0.529,0.523,0.520,0.520,0.522,0.528,0.536,0.549,0.565,0.587,0.614,0.646,0.679,0.709,0.735,0.757,0.777,0.795,0.813,0.833,0.855,0.874,0.885],e:{o:1,b:1,d:1}},
    {l:'Kugu',g:['#2dd4bf','#0f766e'],r:[0.652,0.696,0.763,0.853,0.934,0.980,0.977,0.929,0.854,0.777,0.712,0.659,0.615,0.581,0.555,0.537,0.527,0.523,0.523,0.529,0.540,0.557,0.581,0.612,0.652,0.694,0.732,0.760,0.776,0.778,0.770,0.755,0.741,0.727,0.712,0.693,0.668,0.637,0.600,0.565,0.541,0.526,0.520,0.521,0.527,0.538,0.555,0.581,0.615,0.658,0.714,0.780,0.834,0.855,0.835,0.778,0.708,0.660,0.637,0.635],e:{o:1,b:1,d:1}},
    {l:'Gece',g:['#a78bfa','#5b21b6'],r:[0.741,0.750,0.735,0.708,0.676,0.649,0.637,0.644,0.662,0.684,0.704,0.716,0.717,0.711,0.699,0.690,0.691,0.707,0.731,0.756,0.773,0.780,0.774,0.758,0.738,0.722,0.716,0.721,0.730,0.740,0.748,0.755,0.762,0.775,0.800,0.840,0.891,0.938,0.971,0.980,0.961,0.916,0.854,0.787,0.725,0.677,0.645,0.622,0.603,0.585,0.566,0.547,0.530,0.520,0.522,0.542,0.582,0.631,0.680,0.721],e:{o:1,b:1,d:1}},
    {l:'Safak',g:['#4ade80','#15803d'],r:[0.687,0.745,0.788,0.829,0.872,0.916,0.957,0.980,0.975,0.939,0.882,0.822,0.776,0.743,0.720,0.707,0.704,0.709,0.724,0.739,0.752,0.761,0.766,0.769,0.772,0.775,0.780,0.783,0.784,0.782,0.776,0.769,0.762,0.755,0.749,0.746,0.743,0.741,0.739,0.736,0.735,0.735,0.736,0.738,0.736,0.729,0.712,0.685,0.651,0.611,0.574,0.547,0.529,0.521,0.520,0.528,0.544,0.570,0.606,0.653],e:{o:1,b:1,d:1}},
    {l:'Nilufer',g:['#94a3b8','#334155'],r:[0.554,0.557,0.567,0.581,0.600,0.624,0.652,0.687,0.729,0.775,0.816,0.846,0.859,0.852,0.826,0.788,0.745,0.711,0.686,0.667,0.653,0.641,0.630,0.620,0.611,0.606,0.600,0.592,0.580,0.566,0.550,0.535,0.524,0.520,0.525,0.533,0.539,0.544,0.547,0.551,0.558,0.570,0.591,0.624,0.670,0.733,0.805,0.877,0.937,0.974,0.980,0.953,0.898,0.829,0.756,0.688,0.634,0.596,0.571,0.558],e:{o:1,b:1,d:1}},
    {l:'Gelgit',g:['#c084fc','#7e22ce'],r:[0.781,0.782,0.790,0.804,0.826,0.854,0.886,0.914,0.932,0.934,0.919,0.889,0.852,0.812,0.776,0.746,0.721,0.702,0.686,0.675,0.668,0.666,0.667,0.673,0.684,0.699,0.720,0.742,0.763,0.778,0.780,0.765,0.734,0.693,0.648,0.605,0.572,0.548,0.531,0.522,0.520,0.524,0.536,0.555,0.582,0.619,0.668,0.730,0.808,0.887,0.950,0.980,0.975,0.947,0.908,0.869,0.837,0.813,0.796,0.785],e:{o:1,b:1,d:1}},
    {l:'Ruya',g:['#fbbf24','#ea580c'],r:[0.966,0.973,0.962,0.938,0.906,0.874,0.844,0.814,0.781,0.743,0.701,0.654,0.607,0.568,0.541,0.525,0.520,0.527,0.548,0.581,0.630,0.697,0.775,0.848,0.908,0.950,0.973,0.980,0.978,0.973,0.970,0.969,0.965,0.953,0.929,0.890,0.839,0.778,0.713,0.654,0.607,0.572,0.548,0.534,0.528,0.530,0.540,0.557,0.581,0.612,0.647,0.683,0.719,0.753,0.786,0.817,0.849,0.884,0.919,0.949],e:{o:1,b:1,d:1}},
    {l:'Anadolu',g:['#60a5fa','#1e40af'],r:[0.725,0.677,0.630,0.586,0.555,0.534,0.523,0.520,0.525,0.539,0.562,0.597,0.648,0.706,0.756,0.795,0.820,0.836,0.846,0.853,0.859,0.859,0.854,0.842,0.824,0.805,0.788,0.773,0.759,0.745,0.730,0.717,0.713,0.720,0.738,0.768,0.812,0.875,0.943,0.980,0.955,0.875,0.785,0.723,0.682,0.656,0.642,0.640,0.649,0.671,0.696,0.717,0.733,0.744,0.752,0.756,0.760,0.762,0.758,0.743],e:{o:1,b:1,d:1}},
    {l:'Yosun',g:['#f472b6','#be185d'],r:[0.757,0.767,0.778,0.791,0.808,0.828,0.847,0.862,0.871,0.876,0.877,0.877,0.878,0.881,0.884,0.887,0.890,0.893,0.899,0.908,0.923,0.944,0.966,0.980,0.979,0.956,0.910,0.846,0.773,0.699,0.637,0.590,0.555,0.532,0.521,0.520,0.529,0.550,0.583,0.627,0.684,0.746,0.805,0.851,0.879,0.887,0.877,0.855,0.830,0.808,0.793,0.783,0.777,0.772,0.767,0.762,0.756,0.751,0.750,0.752],e:{o:1,b:1,d:1}},
    {l:'Fasulye',g:['#fb923c','#c2410c'],r:[0.537,0.549,0.570,0.601,0.643,0.699,0.769,0.845,0.915,0.965,0.980,0.959,0.911,0.850,0.789,0.734,0.690,0.654,0.625,0.601,0.582,0.567,0.554,0.544,0.535,0.527,0.522,0.520,0.523,0.529,0.538,0.550,0.564,0.579,0.597,0.617,0.640,0.666,0.693,0.718,0.740,0.759,0.776,0.790,0.805,0.823,0.843,0.861,0.871,0.868,0.848,0.811,0.763,0.709,0.658,0.615,0.582,0.558,0.543,0.536],e:{o:1,b:1,d:1}},
    {l:'Aurora',g:['#f87171','#b91c1c'],r:[0.724,0.711,0.702,0.695,0.690,0.687,0.685,0.684,0.684,0.685,0.690,0.697,0.708,0.724,0.745,0.772,0.800,0.826,0.846,0.856,0.856,0.847,0.832,0.815,0.800,0.787,0.776,0.767,0.756,0.743,0.725,0.702,0.673,0.641,0.608,0.577,0.553,0.536,0.525,0.520,0.521,0.527,0.539,0.559,0.585,0.620,0.665,0.723,0.797,0.878,0.945,0.980,0.975,0.941,0.896,0.851,0.813,0.782,0.758,0.738],e:{o:1,b:1,d:1}},
    {l:'Lotus',g:['#2dd4bf','#0f766e'],r:[0.586,0.563,0.553,0.548,0.546,0.548,0.554,0.565,0.581,0.603,0.634,0.673,0.722,0.784,0.859,0.929,0.976,0.980,0.935,0.857,0.770,0.694,0.635,0.590,0.557,0.535,0.523,0.520,0.526,0.542,0.566,0.597,0.629,0.658,0.687,0.713,0.739,0.766,0.795,0.828,0.864,0.900,0.931,0.953,0.966,0.969,0.966,0.960,0.954,0.949,0.942,0.928,0.904,0.867,0.819,0.764,0.708,0.663,0.627,0.599],e:{o:1,b:1,d:1}},
    {l:'Bosphorus',g:['#a78bfa','#5b21b6'],r:[0.835,0.868,0.864,0.837,0.796,0.753,0.715,0.686,0.663,0.646,0.633,0.622,0.614,0.607,0.602,0.602,0.608,0.622,0.643,0.673,0.713,0.765,0.831,0.901,0.955,0.980,0.969,0.929,0.874,0.818,0.769,0.729,0.697,0.671,0.651,0.638,0.629,0.627,0.630,0.635,0.638,0.639,0.634,0.623,0.607,0.587,0.566,0.546,0.532,0.523,0.520,0.523,0.533,0.549,0.572,0.603,0.642,0.690,0.747,0.803],e:{o:1,b:1,d:1}},
    {l:'Kalp',g:['#f43f5e','#9f1239'],r:[0.574,0.629,0.728,0.807,0.870,0.917,0.950,0.970,0.978,0.980,0.973,0.954,0.918,0.869,0.809,0.744,0.684,0.631,0.587,0.553,0.526,0.508,0.495,0.489,0.492,0.504,0.524,0.556,0.605,0.706,0.778,0.706,0.605,0.556,0.524,0.504,0.492,0.489,0.495,0.508,0.526,0.553,0.587,0.631,0.684,0.744,0.809,0.869,0.918,0.954,0.973,0.980,0.978,0.970,0.950,0.917,0.870,0.807,0.728,0.629],e:{o:1,b:1,d:1}},
    {l:'Koc ♈',g:['#e53935','#bf360c'],t:'burc',r:[0.970,0.966,0.956,0.944,0.934,0.930,0.923,0.906,0.884,0.867,0.860,0.850,0.825,0.795,0.770,0.760,0.750,0.725,0.695,0.670,0.660,0.650,0.625,0.595,0.570,0.560,0.556,0.546,0.534,0.524,0.520,0.526,0.541,0.559,0.574,0.580,0.590,0.615,0.645,0.670,0.680,0.693,0.728,0.772,0.807,0.820,0.830,0.855,0.885,0.910,0.920,0.924,0.934,0.946,0.956,0.960,0.961,0.963,0.967,0.969],e:{o:1,b:1,d:0}},
    {l:'Aslan ♌',g:['#ff8f00','#e65100'],t:'burc',r:[0.880,0.892,0.922,0.954,0.970,0.954,0.901,0.839,0.803,0.810,0.855,0.914,0.954,0.954,0.908,0.842,0.791,0.783,0.817,0.875,0.925,0.939,0.911,0.855,0.802,0.780,0.774,0.759,0.741,0.726,0.720,0.722,0.727,0.733,0.738,0.740,0.738,0.733,0.727,0.722,0.720,0.724,0.734,0.746,0.756,0.760,0.758,0.753,0.747,0.742,0.740,0.748,0.768,0.792,0.812,0.820,0.826,0.841,0.859,0.874],e:{o:1,b:1,d:0}},
    {l:'Yay ♐',g:['#7b1fa2','#4a148c'],t:'burc',r:[0.780,0.772,0.752,0.728,0.708,0.700,0.692,0.672,0.648,0.628,0.620,0.613,0.596,0.574,0.557,0.550,0.557,0.574,0.596,0.613,0.620,0.630,0.655,0.685,0.710,0.720,0.730,0.755,0.785,0.810,0.820,0.828,0.848,0.872,0.892,0.900,0.905,0.917,0.933,0.945,0.950,0.952,0.957,0.963,0.968,0.970,0.965,0.953,0.937,0.925,0.920,0.912,0.892,0.868,0.848,0.840,0.834,0.819,0.801,0.786],e:{o:1,b:1,d:0}},
    {l:'Boga ♉',g:['#2e7d32','#1b5e20'],t:'burc',r:[0.960,0.952,0.930,0.898,0.861,0.825,0.797,0.782,0.778,0.765,0.740,0.708,0.675,0.646,0.627,0.620,0.627,0.646,0.675,0.708,0.740,0.765,0.778,0.782,0.797,0.825,0.861,0.898,0.930,0.952,0.960,0.952,0.930,0.898,0.861,0.825,0.797,0.782,0.778,0.765,0.740,0.708,0.675,0.646,0.627,0.620,0.627,0.646,0.675,0.708,0.740,0.765,0.778,0.782,0.797,0.825,0.861,0.898,0.930,0.952],e:{o:1,b:1,d:0}},
    {l:'Basak ♍',g:['#5d4037','#3e2723'],t:'burc',r:[0.550,0.556,0.575,0.602,0.633,0.662,0.686,0.698,0.703,0.725,0.765,0.816,0.870,0.917,0.949,0.960,0.949,0.917,0.870,0.816,0.765,0.725,0.703,0.698,0.686,0.662,0.633,0.602,0.575,0.556,0.550,0.556,0.575,0.602,0.633,0.662,0.686,0.698,0.703,0.725,0.765,0.816,0.870,0.917,0.949,0.960,0.949,0.917,0.870,0.816,0.765,0.725,0.703,0.698,0.686,0.662,0.633,0.602,0.575,0.556],e:{o:1,b:1,d:0}},
    {l:'Oglak ♑',g:['#37474f','#263238'],t:'burc',r:[0.920,0.918,0.913,0.907,0.902,0.900,0.876,0.816,0.753,0.721,0.697,0.627,0.569,0.566,0.612,0.678,0.729,0.742,0.773,0.830,0.890,0.931,0.940,0.937,0.931,0.925,0.921,0.917,0.883,0.825,0.775,0.759,0.724,0.654,0.587,0.560,0.564,0.574,0.586,0.596,0.600,0.635,0.722,0.813,0.859,0.870,0.901,0.937,0.958,0.959,0.955,0.949,0.943,0.940,0.940,0.937,0.933,0.928,0.924,0.921],e:{o:1,b:1,d:0}},
    {l:'Ikizler ♊',g:['#00897b','#004d40'],t:'burc',r:[0.970,0.959,0.932,0.898,0.871,0.860,0.841,0.791,0.729,0.679,0.660,0.647,0.612,0.568,0.533,0.520,0.533,0.568,0.612,0.647,0.660,0.679,0.729,0.791,0.841,0.860,0.871,0.898,0.932,0.959,0.970,0.959,0.932,0.898,0.871,0.860,0.841,0.791,0.729,0.679,0.660,0.647,0.612,0.568,0.533,0.520,0.533,0.568,0.612,0.647,0.660,0.679,0.729,0.791,0.841,0.860,0.871,0.898,0.932,0.959],e:{o:1,b:1,d:0}},
    {l:'Terazi ♎',g:['#1565c0','#0d47a1'],t:'burc',r:[0.960,0.919,0.823,0.739,0.724,0.785,0.880,0.950,0.949,0.874,0.775,0.721,0.747,0.832,0.922,0.960,0.919,0.823,0.739,0.724,0.785,0.880,0.950,0.949,0.874,0.775,0.721,0.747,0.832,0.922,0.960,0.919,0.823,0.739,0.724,0.785,0.880,0.950,0.949,0.874,0.775,0.721,0.747,0.832,0.922,0.960,0.919,0.823,0.739,0.724,0.785,0.880,0.950,0.949,0.874,0.775,0.721,0.747,0.832,0.922],e:{o:1,b:1,d:0}},
    {l:'Kova ♒',g:['#42a5f5','#1565c0'],t:'burc',r:[0.940,0.909,0.829,0.731,0.651,0.620,0.666,0.779,0.898,0.959,0.935,0.847,0.730,0.629,0.581,0.614,0.726,0.856,0.934,0.927,0.865,0.774,0.690,0.643,0.654,0.720,0.817,0.907,0.957,0.944,0.870,0.761,0.660,0.604,0.620,0.711,0.828,0.909,0.914,0.866,0.790,0.714,0.666,0.667,0.722,0.810,0.898,0.953,0.952,0.890,0.790,0.690,0.628,0.630,0.700,0.803,0.883,0.901,0.914,0.932],e:{o:1,b:1,d:0}},
    {l:'Yengec ♋',g:['#5c6bc0','#283593'],t:'burc',r:[0.920,0.912,0.896,0.862,0.810,0.740,0.660,0.576,0.510,0.472,0.470,0.502,0.560,0.630,0.702,0.780,0.848,0.902,0.938,0.958,0.962,0.955,0.944,0.932,0.922,0.918,0.920,0.930,0.944,0.950,0.950,0.946,0.940,0.932,0.924,0.916,0.912,0.914,0.922,0.932,0.944,0.950,0.950,0.944,0.938,0.938,0.942,0.950,0.954,0.952,0.946,0.936,0.928,0.924,0.920,0.918,0.918,0.918,0.920,0.920],e:{o:1,b:1,d:0}},
    {l:'Akrep ♏',g:['#880e4f','#4a0028'],t:'burc',r:[0.940,0.948,0.956,0.952,0.942,0.932,0.928,0.932,0.940,0.948,0.950,0.944,0.936,0.930,0.930,0.936,0.944,0.948,0.942,0.934,0.928,0.926,0.920,0.900,0.860,0.760,0.580,0.400,0.310,0.295,0.305,0.405,0.590,0.770,0.870,0.910,0.928,0.936,0.946,0.954,0.956,0.950,0.940,0.932,0.930,0.934,0.944,0.950,0.946,0.938,0.932,0.928,0.928,0.934,0.946,0.952,0.948,0.942,0.938,0.938],e:{o:1,b:1,d:0}},
    {l:'Balik ♓',g:['#7e57c2','#4527a0'],t:'burc',r:[0.960,0.956,0.944,0.926,0.908,0.892,0.882,0.878,0.847,0.790,0.730,0.689,0.677,0.632,0.569,0.540,0.569,0.632,0.677,0.690,0.735,0.801,0.864,0.898,0.898,0.885,0.865,0.842,0.821,0.805,0.800,0.792,0.772,0.748,0.728,0.720,0.705,0.665,0.615,0.575,0.560,0.552,0.534,0.521,0.530,0.570,0.610,0.622,0.650,0.701,0.755,0.792,0.802,0.823,0.863,0.905,0.934,0.940,0.947,0.956],e:{o:1,b:1,d:0}}
  ];

  // ═══ DURUM ═══
  var radii = new Float64Array(N);
  var widthCm = 200, lengthCm = 200;
  var edgeType = 'overlok';
  var _lastPresetIdx = -1;
  var _presetEdges = null;
  var _POPULAR_BASE = 'https://dolcevita-massimo.ngrok.io';
  var _popularCache = null; // { items: [...], fetchedAt: ms }
  // v4.0 — Son render sonrasi target canvas bbox cache'i (hotspot dinamik yerlesimi icin).
  // renderPreview() sonunda set edilir, getShape() bunu oncelikle doner. Null ise editor canvas fallback.
  var _lastRenderBounds = null;
  function _applyPresetEdge(idx) {
    var e = (_presetEdges && _presetEdges[String(idx)]) || (PRESETS[idx] && PRESETS[idx].e);
    if (!e) return;
    // FIX (2026-05-04): KALITE bazli edge filter. Plus.js'de bu kontrol var ama
    // sadece !isAmorf koluna giriyor; amorf modunda atlandigi icin Tokyo gibi bordur
    // desteklemeyen kalitelerde bordur sekmesi goruluyordu. Burada cfg.edgeTypes'a
    // gore eksik edge'leri DOM'dan gizliyoruz; preset filter'i da kalitenin uzerine binecek.
    var _qcfg = (window.__OZEL_OLCU_CONFIG__ && window.__OZEL_OLCU_CONFIG__.edgeTypes) || {};
    var labels = document.querySelectorAll('[data-edge]');
    for (var ei = 0; ei < labels.length; ei++) {
      var k = labels[ei].getAttribute('data-edge');
      var qualityHasEdge = !!_qcfg[k];
      var presetOk = k === 'bordur' ? e.d !== false : k === 'biye' ? e.b !== false : e.o !== false;
      var ok = qualityHasEdge && presetOk;
      labels[ei].style.display = qualityHasEdge ? '' : 'none';
      labels[ei].setAttribute('data-edge-allowed', ok ? 'true' : 'false');
      if (!ok) {
        labels[ei].style.opacity = '0.4';
        labels[ei].style.pointerEvents = 'none';
        labels[ei].style.position = 'relative';
      } else {
        labels[ei].style.opacity = '';
        labels[ei].style.pointerEvents = '';
      }
    }
    // Seçili kenar tipi izinsizse varsayılana geç
    var chk = document.querySelector('input[name=ozel-olcu-edge]:checked');
    if (chk) {
      var par = chk.closest('[data-edge]');
      if (par && par.getAttribute('data-edge-allowed') === 'false') {
        var first = document.querySelector('[data-edge][data-edge-allowed="true"] input[name=ozel-olcu-edge]');
        if (first) { first.checked = true; first.dispatchEvent(new Event('change', {bubbles:true})); }
      }
    }
    // Uyarı mesajı elementini güncelle
    _updateEdgeWarning(e);
  }
  function _updateEdgeWarning(edgePerms) {
    var warnEl = document.getElementById('ozel-olcu-edge-warning');
    if (!edgePerms) { if (warnEl) warnEl.style.display = 'none'; return; }
    var blocked = [];
    if (edgePerms.d === false) blocked.push('Bord\u00fcr');
    if (edgePerms.b === false) blocked.push('Biye');
    if (edgePerms.o === false) blocked.push('Overlok');
    if (blocked.length === 0) { if (warnEl) warnEl.style.display = 'none'; return; }
    if (!warnEl) {
      var edgeSection = document.querySelector('[data-edge]');
      if (!edgeSection) return;
      var parent = edgeSection.parentElement;
      if (!parent) return;
      warnEl = document.createElement('div');
      warnEl.id = 'ozel-olcu-edge-warning';
      warnEl.style.cssText = 'margin-top:8px;padding:10px 14px;background:linear-gradient(135deg,#fff8f0,#fff3e6);border:1px solid #f5c6a0;border-radius:8px;font-size:12px;color:#b45309;line-height:1.5;display:flex;align-items:flex-start;gap:8px;';
      parent.parentElement.insertBefore(warnEl, parent.nextSibling);
    }
    warnEl.style.display = 'flex';
    warnEl.innerHTML = '<span style="font-size:16px;flex-shrink:0;">\u26A0\uFE0F</span><span>Bu amorf \u015feklin yap\u0131s\u0131na uygun olmad\u0131\u011f\u0131 i\u00e7in <b>' + blocked.join(', ') + '</b> se\u00e7ene\u011fi kullan\u0131lamamaktad\u0131r.</span>';
  }
  function _fetchPresetEdges() {
    var api = (window.__OZEL_OLCU_CONFIG__ && window.__OZEL_OLCU_CONFIG__.massimoApi) || 'https://dolcevita-massimo.ngrok.io/api/massimo';
    fetch(api.replace('/api/massimo','') + '/api/massimo/ozel-olcu-amorf-preset-edges').then(function(r){return r.json()}).then(function(d){
      if (d && !d.error) { _presetEdges = d; _updateEdgeDots(); console.log('[Amorf] Preset edges loaded:', Object.keys(d).length); }
    }).catch(function(){});
  }
  function _updateEdgeDots() {
    if (!_presetEdges) return;
    var cards = document.querySelectorAll('.ozel-olcu-amorf-preset[data-preset]');
    for (var ci = 0; ci < cards.length; ci++) {
      var idx = cards[ci].getAttribute('data-preset');
      var e = _presetEdges[idx];
      if (!e) continue;
      var dotDiv = cards[ci].querySelector('.ape-dots');
      if (dotDiv) {
        dotDiv.innerHTML = (e.o !== false ? '<span style="width:6px;height:6px;border-radius:50%;background:#2ecc71;display:inline-block;" title="Overlok"></span>' : '') +
          (e.b !== false ? '<span style="width:6px;height:6px;border-radius:50%;background:#3498db;display:inline-block;" title="Biye"></span>' : '') +
          (e.d !== false ? '<span style="width:6px;height:6px;border-radius:50%;background:#e67e22;display:inline-block;" title="Bord\u00fcr"></span>' : '');
      }
    }
  }
  var canvas = null, ctx = null;
  var container = null;
  var isDragging = false;
  var onChangeCallback = null;
  var previewProductCache = { key: null, value: null };
  var previewSwatchCache = {};
  var previewFabricCache = {};

  // ═══ ŞEKİL OLUŞTURMA ═══

  function makeShape(harmonics) {
    var r = new Float64Array(N);
    for (var i = 0; i < N; i++) {
      var angle = (i / N) * Math.PI * 2;
      var val = 0.78;
      for (var j = 0; j < harmonics.length; j++) {
        val += harmonics[j].a * Math.sin(harmonics[j].f * angle + harmonics[j].p);
      }
      r[i] = Math.max(MIN_R, Math.min(MAX_R, val));
    }
    return r;
  }

  function makeUniformShape(radius) {
    var r = new Float64Array(N);
    for (var i = 0; i < N; i++) r[i] = radius;
    return r;
  }

  function randomShape() {
    var nH = 3 + Math.floor(Math.random() * 2);
    var h = [];
    for (var i = 0; i < nH; i++) {
      h.push({
        f: 2 + Math.floor(Math.random() * 4),
        a: 0.04 + Math.random() * 0.10,
        p: Math.random() * Math.PI * 2
      });
    }
    radii = makeShape(h);
    normalizeRadiiToFill(0.96);
    draw();
    fireChange();
  }

  function selectRandomPreset() {
    // Sadece burc olmayan presetlerden rastgele sec
    var genel = [];
    for (var i = 0; i < PRESETS.length; i++) {
      if (PRESETS[i].t !== 'burc') genel.push(i);
    }
    var idx = genel[Math.floor(Math.random() * genel.length)];
    radii = new Float64Array(PRESETS[idx].r);
    normalizeRadiiToFill(0.96);
    _lastPresetIdx = idx;
    _applyPresetEdge(idx);
    draw();
    fireChange();
    return idx;
  }

  // ═══ ŞEKİL NORMALİZASYONU — Bounding box kanvası doldursun ═══
  // [DISABLED 2026-05-06] 63 preset'in hepsinin max radii >=0.956. Bu fonksiyon
  // gereksiz ve yon-bazli scale ile kalp gibi non-square aspect'leri 1:1 kareye
  // deforme ediyor. Tum cagrilar no-op. Geri almak icin asagidaki return; sil.
  function normalizeRadiiToFill(targetFill) {
    return;
    if (!targetFill) targetFill = 0.96;
    // Mevcut bounding box hesapla (normalized koordinatlarda)
    var minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
    for (var i = 0; i < N; i++) {
      var angle = (i / N) * Math.PI * 2 - Math.PI / 2;
      var x = Math.cos(angle) * radii[i];
      var y = Math.sin(angle) * radii[i];
      if (x < minX) minX = x;
      if (x > maxX) maxX = x;
      if (y < minY) minY = y;
      if (y > maxY) maxY = y;
    }
    var curW = maxX - minX;
    var curH = maxY - minY;
    if (curW < 0.01 || curH < 0.01) return;

    // Her eksen icin gereken olcek
    var target = targetFill * 2; // -1..+1 arasi 2 birim, targetFill=0.96 -> 1.92
    var scaleX = target / curW;
    var scaleY = target / curH;

    // Yon bazli olcekleme (seklin karakterini korur)
    for (var j = 0; j < N; j++) {
      var a = (j / N) * Math.PI * 2 - Math.PI / 2;
      var cosA = Math.cos(a);
      var sinA = Math.sin(a);
      var dirScale = Math.sqrt(cosA * cosA * scaleX * scaleX + sinA * sinA * scaleY * scaleY);
      radii[j] = Math.max(MIN_R, Math.min(0.995, radii[j] * dirScale));
    }

    // Merkez kaymasini duzelt (sekil kanvas ortasinda kalsin)
    minX = Infinity; maxX = -Infinity; minY = Infinity; maxY = -Infinity;
    for (var k = 0; k < N; k++) {
      var ak = (k / N) * Math.PI * 2 - Math.PI / 2;
      var xk = Math.cos(ak) * radii[k];
      var yk = Math.sin(ak) * radii[k];
      if (xk < minX) minX = xk;
      if (xk > maxX) maxX = xk;
      if (yk < minY) minY = yk;
      if (yk > maxY) maxY = yk;
    }
    // Merkez ofset: sekil ortalanmamissa her radii'yi hafif ayarla
    var offsetX = (minX + maxX) / 2;
    var offsetY = (minY + maxY) / 2;
    if (Math.abs(offsetX) > 0.02 || Math.abs(offsetY) > 0.02) {
      // Basit merkez duzeltme — buyuk ofsetlerde uygulanir
      console.log('[Amorf] Normalize merkez duzeltme: dx=' + offsetX.toFixed(3) + ' dy=' + offsetY.toFixed(3));
    }

    console.log('[Amorf] Normalize: ' + (curW*100).toFixed(0) + '%x' + (curH*100).toFixed(0) + '% -> ' +
      (((maxX-minX)/2*100)).toFixed(0) + '%x' + (((maxY-minY)/2*100)).toFixed(0) + '% (target=' + (targetFill*100) + '%)');
  }

  // ═══ EDITOR TOOLBAR (kapalı panel + 2 buton) ═══
  function _wrapEditorUI() {
    if (!container || container.querySelector('.amorf-toolbar')) return;
    var panel = document.createElement('div');
    panel.id = 'amorf-editor-panel';
    panel.style.cssText = 'display:none;margin-top:6px;';
    // SADECE canvas ve onun ardindaki dim div'i panel'e tasi.
    // Tab bar (Tumu/Burclar/Trend) ve preset listesi container'da kalir,
    // panel kapali iken bile gorunur olur.
    var _canvas = container.querySelector('#ozel-olcu-amorf-canvas');
    if (_canvas) {
      var _dimDiv = _canvas.nextElementSibling;
      panel.appendChild(_canvas);
      if (_dimDiv) panel.appendChild(_dimDiv);
    }
    var tb = document.createElement('div');
    tb.className = 'amorf-toolbar';
    tb.style.cssText = 'display:flex;gap:8px;margin-bottom:0;';
    tb.innerHTML =
      '<button type="button" id="amorf-btn-random" style="flex:1;padding:8px 10px;border:1px solid #e8622a;border-radius:6px;background:#e8622a;color:#fff;font-size:12px;font-weight:600;cursor:pointer;transition:all .2s;">\u2728 Yeni \u015eekil</button>' +
      '<button type="button" id="amorf-btn-editor" style="flex:1;padding:8px 10px;border:1px solid #ddd;border-radius:6px;background:#fff;color:#888;font-size:12px;font-weight:600;cursor:pointer;transition:all .2s;">\u270f\ufe0f \u015eekli D\u00fczenle</button>';
    container.appendChild(tb);
    // Tasarim Editoru Ac/Kapat satiri (full width, Yeni Sekil + Sekli Duzenle ALTINDA)
    var tasarimRow = document.createElement('div');
    tasarimRow.style.cssText = 'margin-top:6px;';
    tasarimRow.innerHTML = '<button type="button" id="amorf-btn-tasarim-toggle" style="width:100%;padding:8px 10px;border:1.5px solid #6b46c1;border-radius:6px;background:#fff;color:#6b46c1;font-size:12px;font-weight:600;cursor:pointer;transition:all .2s;">\uD83C\uDFA8 Tasar\u0131m Edit\u00f6r\u00fc A\u00e7</button>';
    container.appendChild(tasarimRow);

    // Aspect Suggestion banner (en/boy ideal oneri)
    var aspectBanner = document.createElement('div');
    aspectBanner.id = 'amorf-aspect-suggestion';
    aspectBanner.style.cssText = 'display:none;margin-top:8px;padding:10px 12px;background:#fef3c7;border:1px solid #f59e0b;border-radius:6px;font-size:12px;color:#78350f;align-items:center;gap:8px;flex-wrap:wrap;';
    aspectBanner.innerHTML =
      '<span id="amorf-aspect-text" style="flex:1;min-width:0;line-height:1.4;"></span>' +
      '<button type="button" id="amorf-apply-aspect" data-en="0" data-boy="0" style="padding:6px 12px;border:1px solid #d97706;border-radius:5px;background:#d97706;color:#fff;font-size:11px;font-weight:700;cursor:pointer;white-space:nowrap;">Uygula</button>' +
      '<button type="button" id="amorf-dismiss-aspect" style="padding:6px 8px;border:1px solid #d97706;border-radius:5px;background:#fff;color:#d97706;font-size:11px;font-weight:700;cursor:pointer;line-height:1;" title="Yoksay">\u2715</button>';
    container.appendChild(aspectBanner);
    container.appendChild(panel);
    // Panel default KAPALI (Sekli Duzenle butonu acik state'de bile - kullanici tasarim editoru butonu ile acar)
    var btnR = document.getElementById('amorf-btn-random');
    var btnE = document.getElementById('amorf-btn-editor');
    if (_editorWasOpen && btnE) {
      btnE.style.borderColor = '#e8622a';
      btnE.style.color = '#e8622a';
      btnE.textContent = '\u2715 Edit\u00f6r\u00fc Kapat';
    }
    if (btnR) btnR.addEventListener('click', function(){ selectRandomPreset(); });
    if (btnE) btnE.addEventListener('click', function(){
      var open = panel.style.display !== 'none';
      panel.style.display = open ? 'none' : 'block';
      this.style.borderColor = open ? '#ddd' : '#e8622a';
      this.style.color = open ? '#888' : '#e8622a';
      this.textContent = open ? '\u270f\ufe0f \u015eekli D\u00fczenle' : '\u2715 Edit\u00f6r\u00fc Kapat';
      // Tasarim Editoru butonu metnini de senkronize et (dual control)
      var _btnT = document.getElementById('amorf-btn-tasarim-toggle');
      if (_btnT) _btnT.textContent = open ? '\uD83C\uDFA8 Tasar\u0131m Edit\u00f6r\u00fc A\u00e7' : '\uD83C\uDFA8 Tasar\u0131m Edit\u00f6r\u00fc Kapat';
    });
    // Tasarim Editoru Ac/Kapat butonu - panel toggle + Sekli Duzenle state senkron
    var btnT = document.getElementById('amorf-btn-tasarim-toggle');
    if (btnT) btnT.addEventListener('click', function(){
      var open = panel.style.display !== 'none';
      panel.style.display = open ? 'none' : 'block';
      this.textContent = open ? '\uD83C\uDFA8 Tasar\u0131m Edit\u00f6r\u00fc A\u00e7' : '\uD83C\uDFA8 Tasar\u0131m Edit\u00f6r\u00fc Kapat';
      var _btnE2 = document.getElementById('amorf-btn-editor');
      if (_btnE2) {
        _btnE2.style.borderColor = open ? '#ddd' : '#e8622a';
        _btnE2.style.color = open ? '#888' : '#e8622a';
        _btnE2.textContent = open ? '\u270f\ufe0f \u015eekli D\u00fczenle' : '\u2715 Edit\u00f6r\u00fc Kapat';
      }
    });
    // Aspect suggestion buton handler'lari
    var btnApplyAspect = document.getElementById('amorf-apply-aspect');
    if (btnApplyAspect) btnApplyAspect.addEventListener('click', _applyAspectSuggestion);
    var btnDismissAspect = document.getElementById('amorf-dismiss-aspect');
    if (btnDismissAspect) btnDismissAspect.addEventListener('click', function() {
      var b = document.getElementById('amorf-aspect-suggestion');
      if (b) b.style.display = 'none';
    });
  }

  // ═══ EDITOR DURUMUNU KAPAT (toggle icin) ═══
  function closeEditor() {
    _editorWasOpen = false;
    var _p = document.getElementById('amorf-editor-panel');
    var _btnE = document.getElementById('amorf-btn-editor');
    if (_p) _p.style.display = 'none';
    if (_btnE) {
      _btnE.style.borderColor = '#ddd';
      _btnE.style.color = '#888';
      _btnE.textContent = '\u270f\ufe0f \u015eekli D\u00fczenle';
    }
  }
  // ═══ EDITOR DURUMUNU AC (Amorf'a her tiklamada cagrilir - FIX E2) ═══
  function openEditor() {
    _editorWasOpen = true;
    var _p = document.getElementById('amorf-editor-panel');
    var _btnE = document.getElementById('amorf-btn-editor');
    if (_p) _p.style.display = 'block';
    if (_btnE) {
      _btnE.style.borderColor = '#e8622a';
      _btnE.style.color = '#e8622a';
      _btnE.textContent = '\u2715 Edit\u00f6r\u00fc Kapat';
    }
  }

  // ═══ KOORDİNAT ═══

  function getCanvasSize() {
    if (!canvas) return {w: 400, h: 400, sw: 360, sh: 360, ox: 30, oy: 20};
    return {
      w: canvas.width,
      h: canvas.height,
      sw: canvas.width - 50,
      sh: canvas.height - 50,
      ox: 20,
      oy: 20
    };
  }

  function getPoint(i, sz) {
    var angle = (i / N) * Math.PI * 2 - Math.PI / 2;
    var cx = sz.ox + sz.sw / 2;
    var cy = sz.oy + sz.sh / 2;
    return {
      x: cx + Math.cos(angle) * radii[i % N] * sz.sw / 2,
      y: cy + Math.sin(angle) * radii[i % N] * sz.sh / 2
    };
  }

  function getAllPoints(sz) {
    var pts = [];
    for (var i = 0; i < N; i++) pts.push(getPoint(i, sz));
    return pts;
  }

  // ═══ BEZİER ═══

  function traceBezierPath(ctx2, pts) {
    var n = pts.length;
    ctx2.beginPath();
    ctx2.moveTo(pts[0].x, pts[0].y);
    for (var i = 0; i < n; i++) {
      var p0 = pts[(i - 1 + n) % n], p1 = pts[i];
      var p2 = pts[(i + 1) % n], p3 = pts[(i + 2) % n];
      ctx2.bezierCurveTo(
        p1.x + TENSION * (p2.x - p0.x), p1.y + TENSION * (p2.y - p0.y),
        p2.x - TENSION * (p3.x - p1.x), p2.y - TENSION * (p3.y - p1.y),
        p2.x, p2.y
      );
    }
    ctx2.closePath();
  }

  function drawBezier(ctx2, pts, fill, stroke, lw) {
    traceBezierPath(ctx2, pts);
    if (fill) { ctx2.fillStyle = fill; ctx2.fill(); }
    if (stroke) { ctx2.strokeStyle = stroke; ctx2.lineWidth = lw || 2; ctx2.stroke(); }
  }

  function sampleBezier(pts) {
    var n = pts.length, result = [];
    for (var i = 0; i < n; i++) {
      var p0 = pts[(i-1+n)%n], p1 = pts[i], p2 = pts[(i+1)%n], p3 = pts[(i+2)%n];
      var c1 = {x: p1.x+TENSION*(p2.x-p0.x), y: p1.y+TENSION*(p2.y-p0.y)};
      var c2 = {x: p2.x-TENSION*(p3.x-p1.x), y: p2.y-TENSION*(p3.y-p1.y)};
      for (var j = 0; j < 10; j++) {
        var t = j/10, m = 1-t;
        result.push({
          x: m*m*m*p1.x + 3*m*m*t*c1.x + 3*m*t*t*c2.x + t*t*t*p2.x,
          y: m*m*m*p1.y + 3*m*m*t*c1.y + 3*m*t*t*c2.y + t*t*t*p2.y
        });
      }
    }
    return result;
  }

  function clamp01(v) {
    return v < 0 ? 0 : (v > 1 ? 1 : v);
  }

  function rgbToHsl(r, g, b) {
    r /= 255; g /= 255; b /= 255;
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var h, s;
    var l = (max + min) / 2;
    if (max === min) {
      h = 0;
      s = 0;
    } else {
      var d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r: h = (g - b) / d + (g < b ? 6 : 0); break;
        case g: h = (b - r) / d + 2; break;
        default: h = (r - g) / d + 4; break;
      }
      h /= 6;
    }
    return { h: h, s: s, l: l };
  }

  function hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 1 / 2) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
  }

  function getAverageImageColor(img, cacheKey) {
    if (cacheKey && previewSwatchCache[cacheKey]) return previewSwatchCache[cacheKey];
    var sw = Math.max(1, Math.min(64, img.naturalWidth || img.width || 1));
    var sh = Math.max(1, Math.min(64, img.naturalHeight || img.height || 1));
    var cv = document.createElement('canvas');
    cv.width = sw; cv.height = sh;
    var cx = cv.getContext('2d', { willReadFrequently: true });
    cx.drawImage(img, 0, 0, sw, sh);
    var px = cx.getImageData(0, 0, sw, sh).data;
    var r = 0, g = 0, b = 0, n = 0;
    for (var i = 0; i < px.length; i += 4) {
      r += px[i];
      g += px[i + 1];
      b += px[i + 2];
      n++;
    }
    var color = {
      r: n > 0 ? r / n : 200,
      g: n > 0 ? g / n : 200,
      b: n > 0 ? b / n : 200
    };
    if (cacheKey) previewSwatchCache[cacheKey] = color;
    return color;
  }

  function analyzeFabricMaterial(img, cacheKey, mode) {
    if (cacheKey && previewFabricCache[cacheKey]) return previewFabricCache[cacheKey];

    var srcW = Math.max(8, Math.min(96, img.naturalWidth || img.width || 96));
    var srcH = Math.max(8, Math.min(96, img.naturalHeight || img.height || 96));
    var detailCanvas = document.createElement('canvas');
    detailCanvas.width = srcW;
    detailCanvas.height = srcH;
    var detailCtx = detailCanvas.getContext('2d', { willReadFrequently: true });
    detailCtx.drawImage(img, 0, 0, srcW, srcH);
    var detailData = detailCtx.getImageData(0, 0, srcW, srcH);
    var detailPx = detailData.data;

    var lowW = Math.max(10, Math.round(srcW * 0.35));
    var lowH = Math.max(10, Math.round(srcH * 0.35));
    var lowCanvas = document.createElement('canvas');
    lowCanvas.width = lowW;
    lowCanvas.height = lowH;
    var lowCtx = lowCanvas.getContext('2d', { willReadFrequently: true });
    lowCtx.drawImage(detailCanvas, 0, 0, lowW, lowH);
    var lowData = lowCtx.getImageData(0, 0, lowW, lowH);
    var lowPx = lowData.data;

    var luminances = [];
    for (var i = 0; i < detailPx.length; i += 4) {
      luminances.push(detailPx[i] * 0.2126 + detailPx[i + 1] * 0.7152 + detailPx[i + 2] * 0.0722);
    }
    luminances.sort(function(a, b) { return a - b; });

    var lowIdx = Math.max(0, Math.floor(luminances.length * 0.12));
    var highIdx = Math.min(luminances.length - 1, Math.ceil(luminances.length * 0.88));
    var lumLow = luminances.length ? luminances[lowIdx] : 0;
    var lumHigh = luminances.length ? luminances[highIdx] : 255;

    var baseR = 0, baseG = 0, baseB = 0, baseN = 0;
    var detailLum = 0, detailN = 0;
    for (var di = 0; di < detailPx.length; di += 4) {
      var lum = detailPx[di] * 0.2126 + detailPx[di + 1] * 0.7152 + detailPx[di + 2] * 0.0722;
      detailLum += lum;
      detailN++;
      if (lum < lumLow || lum > lumHigh) continue;
      baseR += detailPx[di];
      baseG += detailPx[di + 1];
      baseB += detailPx[di + 2];
      baseN++;
    }

    if (baseN === 0) {
      for (var fi = 0; fi < detailPx.length; fi += 4) {
        baseR += detailPx[fi];
        baseG += detailPx[fi + 1];
        baseB += detailPx[fi + 2];
        baseN++;
      }
    }

    var baseColor = {
      r: baseN > 0 ? baseR / baseN : 200,
      g: baseN > 0 ? baseG / baseN : 200,
      b: baseN > 0 ? baseB / baseN : 200
    };
    var baseLum = baseColor.r * 0.2126 + baseColor.g * 0.7152 + baseColor.b * 0.0722;

    var material = {
      baseColor: baseColor,
      baseLum: baseLum,
      detailLumBase: detailN > 0 ? detailLum / detailN : baseLum,
      lowPixels: lowPx,
      lowW: lowW,
      lowH: lowH,
      detailPixels: detailPx,
      detailW: srcW,
      detailH: srcH,
      repeatU: mode === 'bordur' ? 4.4 : 5.8,
      repeatV: mode === 'bordur' ? 1.8 : 1.35
    };

    if (cacheKey) previewFabricCache[cacheKey] = material;
    return material;
  }

  function analyzeProductPreview(productImg, targetW, targetH) {
    if (!productImg) return null;
    var key = String(productImg.currentSrc || productImg.src || '') + '|' + targetW + 'x' + targetH;
    if (previewProductCache.key === key && previewProductCache.value) return previewProductCache.value;

    var ac = document.createElement('canvas');
    ac.width = targetW;
    ac.height = targetH;
    var actx = ac.getContext('2d', { willReadFrequently: true });
    actx.drawImage(productImg, 0, 0, targetW, targetH);

    var imgData = actx.getImageData(0, 0, targetW, targetH);
    var d = imgData.data;
    var total = targetW * targetH;
    var brMap = new Float32Array(total);
    var i;

    for (i = 0; i < total; i++) {
      var pi = i * 4;
      brMap[i] = (d[pi] + d[pi + 1] + d[pi + 2]) / 3;
    }
    var mask = buildBackgroundMaskFromEdges(d, brMap, targetW, targetH);

    var cLeft = targetW;
    var cRight = 0;
    var cTop = targetH;
    var cBottom = 0;
    for (var y = 0; y < targetH; y++) {
      for (var x = 0; x < targetW; x++) {
        if (mask[y * targetW + x] === 0) continue;
        if (x < cLeft) cLeft = x;
        if (x > cRight) cRight = x;
        if (y < cTop) cTop = y;
        if (y > cBottom) cBottom = y;
      }
    }

    if (cLeft >= cRight || cTop >= cBottom) {
      cLeft = Math.round(targetW * 0.08);
      cRight = Math.round(targetW * 0.92);
      cTop = Math.round(targetH * 0.08);
      cBottom = Math.round(targetH * 0.92);
    }

    var analysis = {
      canvas: ac,
      imageData: imgData,
      pixels: d,
      brMap: brMap,
      mask: mask,
      bounds: {
        left: cLeft,
        top: cTop,
        right: cRight,
        bottom: cBottom,
        width: Math.max(1, cRight - cLeft),
        height: Math.max(1, cBottom - cTop)
      }
    };
    previewProductCache = { key: key, value: analysis };
    return analysis;
  }

  function sampleBackgroundReference(pixels, brMap, width, height) {
    var sampleW = Math.max(6, Math.round(width * 0.05));
    var sampleH = Math.max(6, Math.round(height * 0.05));
    var regions = [
      { x0: 0, y0: 0, x1: sampleW, y1: sampleH },
      { x0: width - sampleW, y0: 0, x1: width, y1: sampleH },
      { x0: 0, y0: height - sampleH, x1: sampleW, y1: height },
      { x0: width - sampleW, y0: height - sampleH, x1: width, y1: height }
    ];
    var r = 0, g = 0, b = 0, n = 0;
    var brightFloor = Math.max(170, PREVIEW_BG_BRIGHTNESS - 60);
    regions.forEach(function(region) {
      for (var y = region.y0; y < region.y1; y++) {
        for (var x = region.x0; x < region.x1; x++) {
          var idx = y * width + x;
          if (brMap[idx] < brightFloor) continue;
          var pi = idx * 4;
          r += pixels[pi];
          g += pixels[pi + 1];
          b += pixels[pi + 2];
          n++;
        }
      }
    });
    if (!n) {
      regions.forEach(function(region) {
        for (var y1 = region.y0; y1 < region.y1; y1++) {
          for (var x1 = region.x0; x1 < region.x1; x1++) {
            var idx1 = y1 * width + x1;
            var pi1 = idx1 * 4;
            r += pixels[pi1];
            g += pixels[pi1 + 1];
            b += pixels[pi1 + 2];
            n++;
          }
        }
      });
    }
    r = n ? r / n : 245;
    g = n ? g / n : 245;
    b = n ? b / n : 245;
    return { r: r, g: g, b: b, lum: (r + g + b) / 3 };
  }

  function isBackgroundLikePixel(pixels, brMap, idx, bgRef) {
    var br = brMap[idx];
    if (br >= PREVIEW_BG_BRIGHTNESS) return true;
    var pi = idx * 4;
    var r = pixels[pi];
    var g = pixels[pi + 1];
    var b = pixels[pi + 2];
    var spread = Math.max(r, g, b) - Math.min(r, g, b);
    var dr = r - bgRef.r;
    var dg = g - bgRef.g;
    var db = b - bgRef.b;
    var dist = Math.sqrt(dr * dr + dg * dg + db * db);
    return br >= bgRef.lum - 110 && spread <= 42 && dist <= 48; // Monza fix: açık halı kenarı background sayılmasın
  }

  function buildBackgroundMaskFromEdges(pixels, brMap, width, height) {
    var total = width * height;
    var mask = new Uint8Array(total);
    for (var i = 0; i < total; i++) mask[i] = 1;
    var bgRef = sampleBackgroundReference(pixels, brMap, width, height);
    var bgQueue = [];

    for (var bx = 0; bx < width; bx++) {
      if (isBackgroundLikePixel(pixels, brMap, bx, bgRef)) { mask[bx] = 0; bgQueue.push(bx); }
      var bi = (height - 1) * width + bx;
      if (isBackgroundLikePixel(pixels, brMap, bi, bgRef)) { mask[bi] = 0; bgQueue.push(bi); }
    }
    for (var by = 1; by < height - 1; by++) {
      var li = by * width;
      if (isBackgroundLikePixel(pixels, brMap, li, bgRef)) { mask[li] = 0; bgQueue.push(li); }
      var ri = by * width + (width - 1);
      if (isBackgroundLikePixel(pixels, brMap, ri, bgRef)) { mask[ri] = 0; bgQueue.push(ri); }
    }

    while (bgQueue.length > 0) {
      var nextBg = [];
      for (var qi = 0; qi < bgQueue.length; qi++) {
        var ci = bgQueue[qi];
        var cx = ci % width;
        var cy = Math.floor(ci / width);
        for (var dy = -1; dy <= 1; dy++) {
          for (var dx = -1; dx <= 1; dx++) {
            if (dx === 0 && dy === 0) continue;
            var nx = cx + dx;
            var ny = cy + dy;
            if (nx < 0 || nx >= width || ny < 0 || ny >= height) continue;
            var ni = ny * width + nx;
            if (mask[ni] === 0) continue;
            if (isBackgroundLikePixel(pixels, brMap, ni, bgRef)) {
              mask[ni] = 0;
              nextBg.push(ni);
            }
          }
        }
      }
      bgQueue = nextBg;
    }

    return mask;
  }

  function resolveRenderLayout(targetW, targetH, productAnalysis) {
    var ratio = Math.max(widthCm, 1) / Math.max(lengthCm, 1);
    var bounds = productAnalysis ? productAnalysis.bounds : {
      left: Math.round(targetW * 0.08),
      top: Math.round(targetH * 0.08),
      right: Math.round(targetW * 0.92),
      bottom: Math.round(targetH * 0.92),
      width: Math.round(targetW * 0.84),
      height: Math.round(targetH * 0.84)
    };
    // Puffy gibi detection'ı zor olan görsellerde bounds dar kalırsa amorf küçük render oluyor — min %75 fill
    var _minW = targetW * 0.75;
    var _minH = targetH * 0.75;
    if (bounds.width < _minW || bounds.height < _minH) {
      var _cx = (bounds.left + bounds.right) / 2;
      var _cy = (bounds.top + bounds.bottom) / 2;
      var _nW = Math.max(bounds.width, _minW);
      var _nH = Math.max(bounds.height, _minH);
      bounds = {
        left: Math.max(0, Math.round(_cx - _nW / 2)),
        right: Math.min(targetW, Math.round(_cx + _nW / 2)),
        top: Math.max(0, Math.round(_cy - _nH / 2)),
        bottom: Math.min(targetH, Math.round(_cy + _nH / 2)),
        width: 0, height: 0
      };
      bounds.width = bounds.right - bounds.left;
      bounds.height = bounds.bottom - bounds.top;
    }
    var boundW = Math.max(1, bounds.width * 0.985);
    var boundH = Math.max(1, bounds.height * 0.985);
    var drawW, drawH;
    if (ratio >= boundW / Math.max(boundH, 1)) {
      drawW = boundW;
      drawH = drawW / ratio;
    } else {
      drawH = boundH;
      drawW = drawH * ratio;
    }
    return {
      w: targetW,
      h: targetH,
      sw: drawW,
      sh: drawH,
      ox: bounds.left + (bounds.width - drawW) / 2,
      oy: bounds.top + (bounds.height - drawH) / 2
    };
  }

  function buildShapeAnalysis(targetW, targetH, layout) {
    var maskCanvas = document.createElement('canvas');
    maskCanvas.width = targetW;
    maskCanvas.height = targetH;
    var maskCtx = maskCanvas.getContext('2d', { willReadFrequently: true });
    var pts = getAllPoints(layout);
    traceBezierPath(maskCtx, pts);
    maskCtx.fillStyle = '#ffffff';
    maskCtx.fill();

    var sampled = sampleBezier(pts);
    var maskPx = maskCtx.getImageData(0, 0, targetW, targetH).data;
    var total = targetW * targetH;
    var mask = new Uint8Array(total);
    var distMap = new Int16Array(total);
    var seedX = new Int16Array(total);
    var seedY = new Int16Array(total);
    var queue = [];
    var minX = targetW;
    var maxX = 0;
    var minY = targetH;
    var maxY = 0;
    var i;

    for (i = 0; i < total; i++) {
      distMap[i] = -1;
      seedX[i] = -1;
      seedY[i] = -1;
      if (maskPx[i * 4 + 3] > 0) {
        mask[i] = 1;
        var x = i % targetW;
        var y = Math.floor(i / targetW);
        if (x < minX) minX = x;
        if (x > maxX) maxX = x;
        if (y < minY) minY = y;
        if (y > maxY) maxY = y;
      }
    }

    for (var y1 = Math.max(0, minY - 1); y1 <= Math.min(targetH - 1, maxY + 1); y1++) {
      for (var x1 = Math.max(0, minX - 1); x1 <= Math.min(targetW - 1, maxX + 1); x1++) {
        var idx = y1 * targetW + x1;
        if (mask[idx] === 0) continue;
        var boundary = x1 === 0 || x1 === targetW - 1 || y1 === 0 || y1 === targetH - 1;
        if (!boundary) {
          for (var ndy = -1; ndy <= 1 && !boundary; ndy++) {
            for (var ndx = -1; ndx <= 1 && !boundary; ndx++) {
              if (ndx === 0 && ndy === 0) continue;
              var nx = x1 + ndx;
              var ny = y1 + ndy;
              if (nx < 0 || nx >= targetW || ny < 0 || ny >= targetH || mask[ny * targetW + nx] === 0) boundary = true;
            }
          }
        }
        if (boundary) {
          distMap[idx] = 1;
          seedX[idx] = x1;
          seedY[idx] = y1;
          queue.push(idx);
        }
      }
    }

    for (var head = 0; head < queue.length; head++) {
      var ci = queue[head];
      var cx = ci % targetW;
      var cy = Math.floor(ci / targetW);
      var cd = distMap[ci];
      var sx = seedX[ci];
      var sy = seedY[ci];
      for (var qdy = -1; qdy <= 1; qdy++) {
        for (var qdx = -1; qdx <= 1; qdx++) {
          if (qdx === 0 && qdy === 0) continue;
          var qx = cx + qdx;
          var qy = cy + qdy;
          if (qx < 0 || qx >= targetW || qy < 0 || qy >= targetH) continue;
          var qi = qy * targetW + qx;
          if (mask[qi] === 0 || distMap[qi] !== -1) continue;
          distMap[qi] = cd + 1;
          seedX[qi] = sx;
          seedY[qi] = sy;
          queue.push(qi);
        }
      }
    }

    if (minX > maxX || minY > maxY) {
      minX = 0; minY = 0; maxX = targetW - 1; maxY = targetH - 1;
    }

    return {
      width: targetW,
      height: targetH,
      layout: layout,
      maskCanvas: maskCanvas,
      mask: mask,
      distMap: distMap,
      seedX: seedX,
      seedY: seedY,
      pts: pts,
      sampled: sampled,
      centerX: layout.ox + layout.sw / 2,
      centerY: layout.oy + layout.sh / 2,
      bounds: {
        left: Math.max(0, minX),
        top: Math.max(0, minY),
        right: Math.min(targetW - 1, maxX),
        bottom: Math.min(targetH - 1, maxY)
      }
    };
  }

  function buildAlphaMaskCanvas(shapeAnalysis, depth) {
    var cv = document.createElement('canvas');
    cv.width = shapeAnalysis.width;
    cv.height = shapeAnalysis.height;
    var cx = cv.getContext('2d');
    var img = cx.createImageData(shapeAnalysis.width, shapeAnalysis.height);
    var px = img.data;
    for (var y = shapeAnalysis.bounds.top; y <= shapeAnalysis.bounds.bottom; y++) {
      for (var x = shapeAnalysis.bounds.left; x <= shapeAnalysis.bounds.right; x++) {
        var idx = y * shapeAnalysis.width + x;
        if (shapeAnalysis.mask[idx] === 0) continue;
        var alpha = 255;
        if (depth) {
          var dist = shapeAnalysis.distMap[idx];
          if (dist < 1 || dist > depth) continue;
          if (dist <= 2) alpha = Math.round(255 * (dist / 2));
          var blendZone = Math.max(3, Math.round(depth * 0.16));
          if (dist > depth - blendZone) {
            alpha = Math.round(alpha * (1 - ((dist - (depth - blendZone)) / blendZone)));
          }
        }
        px[idx * 4] = 255;
        px[idx * 4 + 1] = 255;
        px[idx * 4 + 2] = 255;
        px[idx * 4 + 3] = alpha;
      }
    }
    cx.putImageData(img, 0, 0);
    return cv;
  }

  function buildOffsetContour(points, offsetPx, centerX, centerY) {
    var result = [];
    for (var i = 0; i < points.length; i++) {
      var prev = points[(i - 1 + points.length) % points.length];
      var next = points[(i + 1) % points.length];
      var tx = next.x - prev.x;
      var ty = next.y - prev.y;
      var len = Math.sqrt(tx * tx + ty * ty) || 1;
      tx /= len;
      ty /= len;
      var nx = -ty;
      var ny = tx;
      var toCenterX = centerX - points[i].x;
      var toCenterY = centerY - points[i].y;
      if ((nx * toCenterX + ny * toCenterY) < 0) {
        nx *= -1;
        ny *= -1;
      }
      result.push({
        x: points[i].x + nx * offsetPx,
        y: points[i].y + ny * offsetPx
      });
    }
    return result;
  }

  function strokeContour(ctx2, contour) {
    if (!contour || contour.length === 0) return;
    ctx2.beginPath();
    ctx2.moveTo(contour[0].x, contour[0].y);
    for (var i = 1; i < contour.length; i++) ctx2.lineTo(contour[i].x, contour[i].y);
    ctx2.closePath();
    ctx2.stroke();
  }

  function drawOuterShadow(targetCtx, pts) {
    targetCtx.save();
    targetCtx.shadowColor = 'rgba(0,0,0,0.14)';
    targetCtx.shadowBlur = 18;
    targetCtx.shadowOffsetY = 6;
    traceBezierPath(targetCtx, pts);
    targetCtx.fillStyle = 'rgba(0,0,0,0)';
    targetCtx.fill();
    targetCtx.restore();
  }

  // ═══ METRİKLER ═══

  function calcMetrics(pts, wCm, hCm, sw, sh) {
    var pxPerCmW = sw / wCm;
    var pxPerCmH = sh / hCm;
    // Alan
    var pixelArea = 0;
    for (var i = 0; i < pts.length; i++) {
      var j = (i + 1) % pts.length;
      pixelArea += pts[i].x * pts[j].y - pts[j].x * pts[i].y;
    }
    pixelArea = Math.abs(pixelArea / 2);
    var areaM2 = pixelArea / (pxPerCmW * pxPerCmH) / 10000;
    // Çevre
    var perimCm = 0;
    for (var k = 0; k < pts.length; k++) {
      var l = (k + 1) % pts.length;
      var dxCm = (pts[l].x - pts[k].x) / pxPerCmW;
      var dyCm = (pts[l].y - pts[k].y) / pxPerCmH;
      perimCm += Math.sqrt(dxCm * dxCm + dyCm * dyCm);
    }
    return { areaM2: areaM2, perimeterM: perimCm / 100 };
  }

  // ═══ ANA ÇİZİM ═══

  function draw() {
    if (!canvas || !ctx) return;
    var sz = getCanvasSize();
    ctx.clearRect(0, 0, sz.w, sz.h);

    // Arka plan
    ctx.fillStyle = '#fefefe';
    ctx.fillRect(0, 0, sz.w, sz.h);

    // Kesikli sınır kutusu
    ctx.strokeStyle = '#e8e8e8';
    ctx.lineWidth = 1;
    ctx.setLineDash([4, 3]);
    ctx.strokeRect(sz.ox, sz.oy, sz.sw, sz.sh);
    ctx.setLineDash([]);

    // Grid (10cm aralikli)
    var gStepX = sz.sw / (widthCm / 10);
    var gStepY = sz.sh / (lengthCm / 10);
    ctx.strokeStyle = '#f0f0f0';
    ctx.lineWidth = 0.5;
    ctx.setLineDash([2, 4]);
    for (var gx = sz.ox + gStepX; gx < sz.ox + sz.sw - 1; gx += gStepX) {
      ctx.beginPath(); ctx.moveTo(gx, sz.oy); ctx.lineTo(gx, sz.oy + sz.sh); ctx.stroke();
    }
    for (var gy = sz.oy + gStepY; gy < sz.oy + sz.sh - 1; gy += gStepY) {
      ctx.beginPath(); ctx.moveTo(sz.ox, gy); ctx.lineTo(sz.ox + sz.sw, gy); ctx.stroke();
    }
    ctx.setLineDash([]);

    // Cetvel (basit)
    ctx.fillStyle = '#ccc';
    ctx.font = '10px sans-serif';
    ctx.textAlign = 'center';
    ctx.fillText(widthCm + ' cm', sz.ox + sz.sw / 2, sz.oy - 5);
    ctx.save();
    ctx.translate(sz.ox - 5, sz.oy + sz.sh / 2);
    ctx.rotate(-Math.PI / 2);
    ctx.fillText(lengthCm + ' cm', 0, 0);
    ctx.restore();

    var pts = getAllPoints(sz);

    // Gölge
    ctx.save();
    ctx.shadowColor = 'rgba(232,98,42,0.08)';
    ctx.shadowBlur = 12;
    ctx.shadowOffsetY = 3;
    drawBezier(ctx, pts, '#fef7f2', null);
    ctx.restore();

    // Ana şekil
    drawBezier(ctx, pts, '#fef3ee', '#e8622a', 2.5);

    // Amorf en x boy olcu cizgisi
    (function() {
      var mnX=9999,mxX=-9999,mnY=9999,mxY=-9999;
      for(var di=0;di<pts.length;di++){
        if(pts[di].x<mnX)mnX=pts[di].x;
        if(pts[di].x>mxX)mxX=pts[di].x;
        if(pts[di].y<mnY)mnY=pts[di].y;
        if(pts[di].y>mxY)mxY=pts[di].y;
      }
      var awCm=Math.round((mxX-mnX)/sz.sw*widthCm);
      var ahCm=Math.round((mxY-mnY)/sz.sh*lengthCm);
      ctx.save();
      ctx.strokeStyle='#e8622a';ctx.lineWidth=0.8;ctx.setLineDash([3,3]);
      var dy1=mnY-12;
      ctx.beginPath();ctx.moveTo(mnX,dy1);ctx.lineTo(mxX,dy1);ctx.stroke();
      ctx.beginPath();ctx.moveTo(mnX,dy1-3);ctx.lineTo(mnX,dy1+3);ctx.stroke();
      ctx.beginPath();ctx.moveTo(mxX,dy1-3);ctx.lineTo(mxX,dy1+3);ctx.stroke();
      var dx1=mnX-12;
      ctx.beginPath();ctx.moveTo(dx1,mnY);ctx.lineTo(dx1,mxY);ctx.stroke();
      ctx.beginPath();ctx.moveTo(dx1-3,mnY);ctx.lineTo(dx1+3,mnY);ctx.stroke();
      ctx.beginPath();ctx.moveTo(dx1-3,mxY);ctx.lineTo(dx1+3,mxY);ctx.stroke();
      ctx.setLineDash([]);
      ctx.fillStyle='#e8622a';ctx.font='bold 11px sans-serif';ctx.textAlign='center';
      ctx.fillText(awCm+' cm',(mnX+mxX)/2,dy1-3);
      ctx.save();ctx.translate(dx1-3,(mnY+mxY)/2);ctx.rotate(-Math.PI/2);
      ctx.fillText(ahCm+' cm',0,0);ctx.restore();
      ctx.restore();
    })();

        // Kenar tipi iç çizgi
    var innerScale = edgeType === 'bordur' ? 0.92 : edgeType === 'biye' ? 0.97 : 0.985;
    var innerPts = [];
    for (var i = 0; i < N; i++) {
      var angle = (i / N) * Math.PI * 2 - Math.PI / 2;
      var cx = sz.ox + sz.sw / 2;
      var cy = sz.oy + sz.sh / 2;
      innerPts.push({
        x: cx + Math.cos(angle) * radii[i] * innerScale * sz.sw / 2,
        y: cy + Math.sin(angle) * radii[i] * innerScale * sz.sh / 2
      });
    }
    if (edgeType === 'overlok') {
      ctx.setLineDash([3, 2]);
      drawBezier(ctx, innerPts, null, '#e8622a22', 1);
      ctx.setLineDash([]);
    } else {
      drawBezier(ctx, innerPts, null, edgeType === 'bordur' ? '#e8622a55' : '#e8622a33', edgeType === 'bordur' ? 1.5 : 1);
    }
  }

  // ═══ GİYDİRME (fabric texture → amorf mask) ═══

  function getScaledEdgeDepth(targetW, productImg, mode, layoutSw) {
    // Sabit cm degerleri (net kenar genisligi — blendZone ile toplam gercek olcuye ulasilir)
    var _qc = (window.__OZEL_OLCU_CONFIG__ && window.__OZEL_OLCU_CONFIG__.qualityCode || '').toLowerCase();
    var BORDUR_CM = _qc.indexOf('paradiso') >= 0 ? 4.4 : 4.0;
    var BIYE_CM = _qc.indexOf('paradiso') >= 0 ? 2.0 : 1.6;
    // Gorsel render scale: Paradiso icin gercek uretim olculeri (BORDUR=4.4cm, BIYE=2cm)
    // SABIT kalir, ama ekranda dikdortgen motoru (ozel-olcu-preview.js) ile tutarlilik
    // icin yarisi cizilir. Diger kaliteler etkilenmez.
    var BIYE_VISUAL_SCALE = _qc.indexOf('paradiso') >= 0 ? 0.5 : 0.625;
    var BORDUR_VISUAL_SCALE = _qc.indexOf('paradiso') >= 0 ? 0.5 : 0.625;
    var OVERLOK_CM = 0.3;
    if (layoutSw && widthCm > 0) {
      var pxPerCm = layoutSw / widthCm;
      if (mode === 'bordur') return Math.max(6, Math.round(BORDUR_CM * BORDUR_VISUAL_SCALE * pxPerCm));
      if (mode === 'overlok') return Math.max(2, Math.round(OVERLOK_CM * pxPerCm));
      return Math.max(3, Math.round(BIYE_CM * BIYE_VISUAL_SCALE * pxPerCm));
    }
    // Fallback: eski sabit deger (layoutSw yoksa)
    var naturalW = productImg ? (productImg.naturalWidth || productImg.width || targetW) : targetW;
    var scale = targetW / Math.max(naturalW, 1);
    if (mode === 'bordur') return Math.max(6, Math.round(BORDUR_CM * BORDUR_VISUAL_SCALE * 2.75 * scale));
    if (mode === 'overlok') return Math.max(2, Math.round(OVERLOK_CM * 2.75 * scale));
    return Math.max(3, Math.round(BIYE_CM * BIYE_VISUAL_SCALE * 2.75 * scale));
  }

  function createMaskedSourceCanvas(productAnalysis, shapeAnalysis) {
    var cv = document.createElement('canvas');
    cv.width = shapeAnalysis.width;
    cv.height = shapeAnalysis.height;
    var cx = cv.getContext('2d');
    cx.drawImage(productAnalysis.canvas, 0, 0);
    cx.globalCompositeOperation = 'destination-in';
    cx.drawImage(shapeAnalysis.maskCanvas, 0, 0);
    cx.globalCompositeOperation = 'source-over';
    return cv;
  }

  function renderInteriorShape(productAnalysis, shapeAnalysis, edgeDepth) {
    // Adım 1: 1:1 maskeleme (stretch yok — overlok pattern'i)
    var cv = createMaskedSourceCanvas(productAnalysis, shapeAnalysis);
    var cx = cv.getContext('2d', { willReadFrequently: true });

    // Adım 2: Piksel verisi
    var data = cx.getImageData(0, 0, shapeAnalysis.width, shapeAnalysis.height);
    var px = data.data;
    var sourcePx = productAnalysis.pixels;

    // Adım 3: Edge cleanup — kenar bölgesindeki pikselleri iç doku ile değiştir
    var cleanupInset = Math.max(5, Math.round(edgeDepth + 2));

    for (var y = shapeAnalysis.bounds.top; y <= shapeAnalysis.bounds.bottom; y++) {
      for (var x = shapeAnalysis.bounds.left; x <= shapeAnalysis.bounds.right; x++) {
        var idx = y * shapeAnalysis.width + x;
        if (shapeAnalysis.mask[idx] === 0) continue;
        var dist = shapeAnalysis.distMap[idx];
        if (dist < 1 || dist > edgeDepth) continue;

        var sx = shapeAnalysis.seedX[idx];
        var sy = shapeAnalysis.seedY[idx];
        var vx = x - sx;
        var vy = y - sy;
        var vLen = Math.sqrt(vx * vx + vy * vy);
        if (vLen < 0.001) {
          vx = shapeAnalysis.centerX - x;
          vy = shapeAnalysis.centerY - y;
          vLen = Math.sqrt(vx * vx + vy * vy) || 1;
        }
        vx /= vLen;
        vy /= vLen;

        var srcX = Math.max(0, Math.min(shapeAnalysis.width - 1, Math.round(x + vx * cleanupInset)));
        var srcY = Math.max(0, Math.min(shapeAnalysis.height - 1, Math.round(y + vy * cleanupInset)));
        var pi = idx * 4;
        var spi = (srcY * shapeAnalysis.width + srcX) * 4;
        var cleanupBlend = 0.84 + (1 - Math.min(dist / Math.max(edgeDepth, 1), 1)) * 0.16;
        px[pi]     = Math.round(sourcePx[spi]     * cleanupBlend + px[pi]     * (1 - cleanupBlend));
        px[pi + 1] = Math.round(sourcePx[spi + 1] * cleanupBlend + px[pi + 1] * (1 - cleanupBlend));
        px[pi + 2] = Math.round(sourcePx[spi + 2] * cleanupBlend + px[pi + 2] * (1 - cleanupBlend));
      }
    }

    // Adım 4: Temizlenmiş pikselleri yaz
    cx.putImageData(data, 0, 0);

    // Adım 5: Alpha mask (fadeStart/fadeSpan geçişi)
    var innerMask = document.createElement('canvas');
    innerMask.width = shapeAnalysis.width;
    innerMask.height = shapeAnalysis.height;
    var maskCtx = innerMask.getContext('2d', { willReadFrequently: true });
    var maskData = maskCtx.createImageData(shapeAnalysis.width, shapeAnalysis.height);
    var maskPx = maskData.data;
    // blendZone büyük → fadeStart küçük → biye daha görünür (önceki 0.22 çok küçüktü)
    var blendZone = Math.max(2, Math.round(edgeDepth * 0.65));
    var fadeStart = Math.max(1, edgeDepth - blendZone);
    var fadeSpan = Math.max(2, edgeDepth + 2 - fadeStart);

    for (var y2 = shapeAnalysis.bounds.top; y2 <= shapeAnalysis.bounds.bottom; y2++) {
      for (var x2 = shapeAnalysis.bounds.left; x2 <= shapeAnalysis.bounds.right; x2++) {
        var idx2 = y2 * shapeAnalysis.width + x2;
        if (shapeAnalysis.mask[idx2] === 0) continue;
        var dist2 = shapeAnalysis.distMap[idx2];
        // Sacak modu (edgeDepth=0): dist=0 dahil tüm şekil pikselleri opak — boşluk yok
        if (edgeDepth <= 0) {
          var pi2 = idx2 * 4;
          maskPx[pi2] = 255; maskPx[pi2+1] = 255; maskPx[pi2+2] = 255; maskPx[pi2+3] = 255;
          continue;
        }
        if (dist2 < 1 || dist2 <= fadeStart) continue;
        var alpha = dist2 >= edgeDepth + 2 ? 255 : Math.round(255 * clamp01((dist2 - fadeStart) / fadeSpan));
        var pi2 = idx2 * 4;
        maskPx[pi2]     = 255;
        maskPx[pi2 + 1] = 255;
        maskPx[pi2 + 2] = 255;
        maskPx[pi2 + 3] = alpha;
      }
    }

    maskCtx.putImageData(maskData, 0, 0);
    cx.globalCompositeOperation = 'destination-in';
    cx.drawImage(innerMask, 0, 0);
    cx.globalCompositeOperation = 'source-over';
    return cv;
  }

  function samplePixelInto(sourcePx, width, height, x, y, out) {
    var sx = Math.max(0, Math.min(width - 1, Math.round(x)));
    var sy = Math.max(0, Math.min(height - 1, Math.round(y)));
    var pi = (sy * width + sx) * 4;
    out.r = sourcePx[pi];
    out.g = sourcePx[pi + 1];
    out.b = sourcePx[pi + 2];
    return out;
  }

  function sampleWrappedPixelInto(sourcePx, width, height, u, v, out) {
    u = u % 1;
    v = v % 1;
    if (u < 0) u += 1;
    if (v < 0) v += 1;
    return samplePixelInto(sourcePx, width, height, u * (width - 1), v * (height - 1), out);
  }

  function sampleMappedEdgeSource(productAnalysis, shapeAnalysis, idx, dist, out) {
    var bounds = productAnalysis.bounds;
    var shapeBounds = shapeAnalysis.bounds;
    var seedX = shapeAnalysis.seedX[idx];
    var seedY = shapeAnalysis.seedY[idx];
    var dx = seedX - shapeAnalysis.centerX;
    var dy = seedY - shapeAnalysis.centerY;
    var ax = Math.abs(dx);
    var ay = Math.abs(dy);
    var sum = ax + ay || 1;
    var hWeight = ax / sum;
    var vWeight = ay / sum;
    var nx = clamp01((seedX - shapeBounds.left) / Math.max(1, shapeBounds.right - shapeBounds.left));
    var ny = clamp01((seedY - shapeBounds.top) / Math.max(1, shapeBounds.bottom - shapeBounds.top));
    var inset = Math.max(1, dist - 1);
    var hx = dx < 0 ? bounds.left + inset : bounds.right - inset;
    var hy = bounds.top + ny * Math.max(1, bounds.bottom - bounds.top);
    var vx = bounds.left + nx * Math.max(1, bounds.right - bounds.left);
    var vy = dy < 0 ? bounds.top + inset : bounds.bottom - inset;

    var hsx = Math.max(0, Math.min(shapeAnalysis.width - 1, Math.round(hx)));
    var hsy = Math.max(0, Math.min(shapeAnalysis.height - 1, Math.round(hy)));
    var vsx = Math.max(0, Math.min(shapeAnalysis.width - 1, Math.round(vx)));
    var vsy = Math.max(0, Math.min(shapeAnalysis.height - 1, Math.round(vy)));
    var hpi = (hsy * shapeAnalysis.width + hsx) * 4;
    var vpi = (vsy * shapeAnalysis.width + vsx) * 4;

    out.r = Math.round(productAnalysis.pixels[hpi] * hWeight + productAnalysis.pixels[vpi] * vWeight);
    out.g = Math.round(productAnalysis.pixels[hpi + 1] * hWeight + productAnalysis.pixels[vpi + 1] * vWeight);
    out.b = Math.round(productAnalysis.pixels[hpi + 2] * hWeight + productAnalysis.pixels[vpi + 2] * vWeight);
    return out;
  }

  function detectRealEdgeSource(productAnalysis, edgeDepth, mode, productSrc) {
    var src = String(productSrc || '');
    // Non-Paradiso: URL'de 'biye'/'bordur' geçmez — Paradiso stüdyo URL pattern'ini kontrol et
    var _qcAmorf = (window.__OZEL_OLCU_CONFIG__ && window.__OZEL_OLCU_CONFIG__.qualityCode || '').toLowerCase();
    if (_qcAmorf.indexOf('paradiso') < 0) return true; // Oda foto kaliteleri: tam opacity
    if (mode === 'bordur' ? /bordur/i.test(src) : /biye/i.test(src)) return true;
    if (!productAnalysis || !productAnalysis.pixels || !productAnalysis.bounds) return false;

    var bounds = productAnalysis.bounds;
    var px = productAnalysis.pixels;
    var w = productAnalysis.canvas ? productAnalysis.canvas.width : 0;
    var outerInset = Math.max(2, Math.round(edgeDepth * 0.9));
    var innerInset = Math.max(8, Math.round(edgeDepth * (mode === 'bordur' ? 1.15 : 1.0)));
    var outerR = 0, outerG = 0, outerB = 0, outerN = 0;
    var innerR = 0, innerG = 0, innerB = 0, innerN = 0;

    for (var y = bounds.top; y <= bounds.bottom; y += 4) {
      for (var x = bounds.left; x <= bounds.right; x += 4) {
        var nearEdge = Math.min(x - bounds.left, bounds.right - x, y - bounds.top, bounds.bottom - y);
        var pi = (y * w + x) * 4;
        if (nearEdge <= outerInset) {
          outerR += px[pi];
          outerG += px[pi + 1];
          outerB += px[pi + 2];
          outerN++;
        } else if (
          x >= bounds.left + innerInset &&
          x <= bounds.right - innerInset &&
          y >= bounds.top + innerInset &&
          y <= bounds.bottom - innerInset
        ) {
          innerR += px[pi];
          innerG += px[pi + 1];
          innerB += px[pi + 2];
          innerN++;
        }
      }
    }

    if (outerN < 12 || innerN < 12) return false;

    outerR /= outerN; outerG /= outerN; outerB /= outerN;
    innerR /= innerN; innerG /= innerN; innerB /= innerN;

    var outerLum = outerR * 0.2126 + outerG * 0.7152 + outerB * 0.0722;
    var innerLum = innerR * 0.2126 + innerG * 0.7152 + innerB * 0.0722;
    var lumDelta = Math.abs(outerLum - innerLum);
    var colorDelta = Math.sqrt(
      (outerR - innerR) * (outerR - innerR) +
      (outerG - innerG) * (outerG - innerG) +
      (outerB - innerB) * (outerB - innerB)
    );

    return mode === 'bordur'
      ? (colorDelta >= 10 || lumDelta >= 6)
      : (colorDelta >= 6 || lumDelta >= 4);
  }

  function renderOverlokShape(productAnalysis, shapeAnalysis, swatch, edgeDepth) {
    var cv = createMaskedSourceCanvas(productAnalysis, shapeAnalysis);
    var cx = cv.getContext('2d', { willReadFrequently: true });
    var data = cx.getImageData(0, 0, shapeAnalysis.width, shapeAnalysis.height);
    var px = data.data;
    var sourcePx = productAnalysis.pixels;
    var cleanupInset = Math.max(5, Math.round(edgeDepth + 2));
    var hsl = rgbToHsl(swatch.r, swatch.g, swatch.b);
    var threadL = clamp01(hsl.l * 0.84);
    var threadS = clamp01(hsl.s * 0.92 + 0.03);
    var q = threadL < 0.5 ? threadL * (1 + threadS) : threadL + threadS - threadL * threadS;
    var p = 2 * threadL - q;
    var threadR = Math.round(hue2rgb(p, q, hsl.h + 1 / 3) * 255);
    var threadG = Math.round(hue2rgb(p, q, hsl.h) * 255);
    var threadB = Math.round(hue2rgb(p, q, hsl.h - 1 / 3) * 255);
    var shadowR = Math.round(threadR * 0.72);
    var shadowG = Math.round(threadG * 0.72);
    var shadowB = Math.round(threadB * 0.72);

    for (var y = shapeAnalysis.bounds.top; y <= shapeAnalysis.bounds.bottom; y++) {
      for (var x = shapeAnalysis.bounds.left; x <= shapeAnalysis.bounds.right; x++) {
        var idx = y * shapeAnalysis.width + x;
        if (shapeAnalysis.mask[idx] === 0) continue;
        var dist = shapeAnalysis.distMap[idx];
        if (dist < 1 || dist > edgeDepth) continue;

        var sx = shapeAnalysis.seedX[idx];
        var sy = shapeAnalysis.seedY[idx];
        var vx = x - sx;
        var vy = y - sy;
        var vLen = Math.sqrt(vx * vx + vy * vy);
        if (vLen < 0.001) {
          vx = shapeAnalysis.centerX - x;
          vy = shapeAnalysis.centerY - y;
          vLen = Math.sqrt(vx * vx + vy * vy) || 1;
        }
        vx /= vLen;
        vy /= vLen;

        var srcX = Math.max(0, Math.min(shapeAnalysis.width - 1, Math.round(x + vx * cleanupInset)));
        var srcY = Math.max(0, Math.min(shapeAnalysis.height - 1, Math.round(y + vy * cleanupInset)));
        var pi = idx * 4;
        var spi = (srcY * shapeAnalysis.width + srcX) * 4;
        var cleanupBlend = 0.84 + (1 - Math.min(dist / Math.max(edgeDepth, 1), 1)) * 0.16;
        px[pi] = Math.round(sourcePx[spi] * cleanupBlend + px[pi] * (1 - cleanupBlend));
        px[pi + 1] = Math.round(sourcePx[spi + 1] * cleanupBlend + px[pi + 1] * (1 - cleanupBlend));
        px[pi + 2] = Math.round(sourcePx[spi + 2] * cleanupBlend + px[pi + 2] * (1 - cleanupBlend));

        if (dist <= 2) {
          var stitchPattern = 0.5 + 0.5 * Math.sin(sx * 0.37 + sy * 0.19 + x * 0.08 + y * 0.04);
          var stitchBlend = 0.42 + stitchPattern * 0.24;
          px[pi] = Math.round(threadR * stitchBlend + px[pi] * (1 - stitchBlend));
          px[pi + 1] = Math.round(threadG * stitchBlend + px[pi + 1] * (1 - stitchBlend));
          px[pi + 2] = Math.round(threadB * stitchBlend + px[pi + 2] * (1 - stitchBlend));
        } else if (dist === 3) {
          px[pi] = Math.round(shadowR * 0.18 + px[pi] * 0.82);
          px[pi + 1] = Math.round(shadowG * 0.18 + px[pi + 1] * 0.82);
          px[pi + 2] = Math.round(shadowB * 0.18 + px[pi + 2] * 0.82);
        }
      }
    }

    cx.putImageData(data, 0, 0);
    cx.globalCompositeOperation = 'destination-in';
    cx.drawImage(shapeAnalysis.maskCanvas, 0, 0);
    cx.globalCompositeOperation = 'source-over';
    return cv;
  }

  function renderEdgeBandLayer(productAnalysis, shapeAnalysis, fabricAnalysis, edgeDepth, mode, productSrc, forceSynthetic) {
    var w = shapeAnalysis.width;
    var h = shapeAnalysis.height;
    var edgeCanvas = document.createElement('canvas');
    edgeCanvas.width = w;
    edgeCanvas.height = h;
    var edgeCtx = edgeCanvas.getContext('2d');
    var edgeData = edgeCtx.createImageData(w, h);
    var edgePx = edgeData.data;
    var detailCanvas = document.createElement('canvas');
    detailCanvas.width = w;
    detailCanvas.height = h;
    var detailCtx = detailCanvas.getContext('2d');
    var detailData = detailCtx.createImageData(w, h);
    var detailPx = detailData.data;
    var srcPx = productAnalysis.pixels;
    var baseColor = fabricAnalysis.baseColor;
    var hasRealSource = forceSynthetic ? false : detectRealEdgeSource(productAnalysis, edgeDepth, mode, productSrc);
    var avgLum = 0;
    var avgCount = 0;
    var mappedColor = { r: 0, g: 0, b: 0 };
    var fabricLow = { r: 0, g: 0, b: 0 };
    var fabricDetail = { r: 0, g: 0, b: 0 };

    for (var sy = shapeAnalysis.bounds.top; sy <= shapeAnalysis.bounds.bottom; sy += 2) {
      for (var sx = shapeAnalysis.bounds.left; sx <= shapeAnalysis.bounds.right; sx += 2) {
        var si = sy * w + sx;
        if (shapeAnalysis.mask[si] === 0) continue;
        var sDist = shapeAnalysis.distMap[si];
        if (sDist < 1 || sDist > edgeDepth) continue;
        sampleMappedEdgeSource(productAnalysis, shapeAnalysis, si, sDist, mappedColor);
        avgLum += mappedColor.r * 0.2126 + mappedColor.g * 0.7152 + mappedColor.b * 0.0722;
        avgCount++;
      }
    }
    var avgLumBase = avgCount > 0 ? avgLum / avgCount : 200;

    for (var y1 = shapeAnalysis.bounds.top; y1 <= shapeAnalysis.bounds.bottom; y1++) {
      for (var x1 = shapeAnalysis.bounds.left; x1 <= shapeAnalysis.bounds.right; x1++) {
        var idx = y1 * w + x1;
        if (shapeAnalysis.mask[idx] === 0) continue;
        var dist = shapeAnalysis.distMap[idx];
        if (dist < 1 || dist > edgeDepth) continue;

        var pi = idx * 4;
        if (hasRealSource) sampleMappedEdgeSource(productAnalysis, shapeAnalysis, idx, dist, mappedColor);
        else samplePixelInto(srcPx, w, h, x1, y1, mappedColor);
        var srcR = mappedColor.r;
        var srcG = mappedColor.g;
        var srcB = mappedColor.b;
        var srcLum = srcR * 0.2126 + srcG * 0.7152 + srcB * 0.0722;
        var gray = Math.round(srcLum);
        detailPx[pi] = gray;
        detailPx[pi + 1] = gray;
        detailPx[pi + 2] = gray;
        detailPx[pi + 3] = 255;

        var lumRatio = srcLum / Math.max(avgLumBase, 1);
        lumRatio = 1 + (lumRatio - 1) * (mode === 'bordur' ? 0.15 : 0.52);
        if (mode === 'bordur') {
          if (lumRatio < 0.95) lumRatio = 0.95;
          if (lumRatio > 1.05) lumRatio = 1.05;
        } else {
          if (lumRatio < 0.88) lumRatio = 0.88;
          if (lumRatio > 1.10) lumRatio = 1.10;
        }

        var seedX = shapeAnalysis.seedX[idx];
        var seedY = shapeAnalysis.seedY[idx];
        var angle = Math.atan2(seedY - shapeAnalysis.centerY, seedX - shapeAnalysis.centerX);
        if (angle < 0) angle += Math.PI * 2;
        var u = angle / (Math.PI * 2);
        var v = clamp01((dist - 1) / Math.max(edgeDepth - 1, 1));

        sampleWrappedPixelInto(
          fabricAnalysis.lowPixels,
          fabricAnalysis.lowW,
          fabricAnalysis.lowH,
          u * (mode === 'bordur' ? 1.35 : 1.55) + v * (mode === 'bordur' ? 0.12 : 0.05),
          v * (mode === 'bordur' ? 0.92 : 0.76) + u * 0.04,
          fabricLow
        );
        sampleWrappedPixelInto(
          fabricAnalysis.detailPixels,
          fabricAnalysis.detailW,
          fabricAnalysis.detailH,
          u * fabricAnalysis.repeatU + v * (mode === 'bordur' ? 0.22 : 0.10),
          v * fabricAnalysis.repeatV + u * 0.08,
          fabricDetail
        );

        var detailLum = fabricDetail.r * 0.2126 + fabricDetail.g * 0.7152 + fabricDetail.b * 0.0722;
        var detailRatio = detailLum / Math.max(fabricAnalysis.detailLumBase, 1);
        detailRatio = 1 + (detailRatio - 1) * (mode === 'bordur' ? 0.08 : 0.12);
        if (mode === 'bordur') {
          if (detailRatio < 0.97) detailRatio = 0.97;
          if (detailRatio > 1.03) detailRatio = 1.03;
        } else {
          if (detailRatio < 0.96) detailRatio = 0.96;
          if (detailRatio > 1.05) detailRatio = 1.05;
        }

        var anchorMix = mode === 'bordur' ? 0.38 : 0.20;
        var textureMix = mode === 'bordur' ? 0.16 : 0.09;
        var baseR = fabricLow.r * (1 - anchorMix) + baseColor.r * anchorMix;
        var baseG = fabricLow.g * (1 - anchorMix) + baseColor.g * anchorMix;
        var baseB = fabricLow.b * (1 - anchorMix) + baseColor.b * anchorMix;
        baseR = baseR * (1 - textureMix) + fabricDetail.r * textureMix;
        baseG = baseG * (1 - textureMix) + fabricDetail.g * textureMix;
        baseB = baseB * (1 - textureMix) + fabricDetail.b * textureMix;

        var nap = mode === 'bordur'
          ? Math.sin(x1 * 0.18) * 0.002 + Math.sin(x1 * 0.043 + y1 * 0.07) * 0.003
          : Math.sin(x1 * 0.055 + y1 * 0.08) * 0.004 + Math.sin(x1 * 0.018 - y1 * 0.045) * 0.003;
        var shade = lumRatio * detailRatio + nap;
        if (mode === 'bordur') {
          if (shade < 0.94) shade = 0.94;
          if (shade > 1.06) shade = 1.06;
        } else {
          if (shade < 0.90) shade = 0.90;
          if (shade > 1.12) shade = 1.12;
        }

        var outR = Math.round(Math.max(0, Math.min(255, baseR * shade)));
        var outG = Math.round(Math.max(0, Math.min(255, baseG * shade)));
        var outB = Math.round(Math.max(0, Math.min(255, baseB * shade)));

        var blend = mode === 'bordur'
          ? (hasRealSource ? 0.99 : 0.98)
          : (hasRealSource ? 0.97 : 0.95);
        if (dist <= 1) blend *= 0.85;
        var blendZone = Math.max(mode === 'bordur' ? 4 : 3, Math.round(edgeDepth * (mode === 'bordur' ? 0.15 : 0.18)));
        if (dist > edgeDepth - blendZone) {
          blend *= 1 - ((dist - (edgeDepth - blendZone)) / blendZone);
        }

        edgePx[pi] = Math.round(outR * blend + srcR * (1 - blend));
        edgePx[pi + 1] = Math.round(outG * blend + srcG * (1 - blend));
        edgePx[pi + 2] = Math.round(outB * blend + srcB * (1 - blend));
        edgePx[pi + 3] = 255;
      }
    }

    edgeCtx.putImageData(edgeData, 0, 0);
    detailCtx.putImageData(detailData, 0, 0);
    var bandMask = buildAlphaMaskCanvas(shapeAnalysis, edgeDepth);
    edgeCtx.globalCompositeOperation = 'destination-in';
    edgeCtx.drawImage(bandMask, 0, 0);
    detailCtx.globalCompositeOperation = 'destination-in';
    detailCtx.drawImage(bandMask, 0, 0);
    detailCtx.globalCompositeOperation = 'source-over';
    edgeCtx.globalCompositeOperation = 'soft-light';
    edgeCtx.globalAlpha = mode === 'bordur' ? (hasRealSource ? 0.14 : 0.10) : (hasRealSource ? 0.06 : 0.04);
    edgeCtx.filter = 'contrast(1.04)';
    edgeCtx.drawImage(detailCanvas, 0, 0);
    edgeCtx.filter = 'none';
    edgeCtx.globalAlpha = 1;
    edgeCtx.globalCompositeOperation = 'destination-in';
    edgeCtx.drawImage(bandMask, 0, 0);
    edgeCtx.globalCompositeOperation = 'source-over';
    return edgeCanvas;
  }

  function applyContourFinishing(targetCtx, shapeAnalysis, edgeDepth, mode, swatch, hasRealSource) {
    targetCtx.save();
    targetCtx.lineJoin = 'round';
    targetCtx.lineCap = 'round';

    if (mode === 'overlok') {
      var hsl = rgbToHsl(swatch.r, swatch.g, swatch.b);
      var threadL = clamp01(hsl.l * 0.84);
      var threadS = clamp01(hsl.s * 0.92 + 0.03);
      var tq = threadL < 0.5 ? threadL * (1 + threadS) : threadL + threadS - threadL * threadS;
      var tp = 2 * threadL - tq;
      targetCtx.strokeStyle = 'rgba(' +
        Math.round(hue2rgb(tp, tq, hsl.h + 1 / 3) * 255) + ',' +
        Math.round(hue2rgb(tp, tq, hsl.h) * 255) + ',' +
        Math.round(hue2rgb(tp, tq, hsl.h - 1 / 3) * 255) + ',0.45)';
      targetCtx.lineWidth = Math.max(1, edgeDepth * 0.08);
      targetCtx.setLineDash([Math.max(2, edgeDepth * 0.18), Math.max(1, edgeDepth * 0.12)]);
      traceBezierPath(targetCtx, shapeAnalysis.pts);
      targetCtx.stroke();
      targetCtx.setLineDash([]);
    } else {
      var innerOffset = Math.max(1, edgeDepth - Math.max(1.5, edgeDepth * (mode === 'bordur' ? 0.02 : 0.04)));
      var innerContour = buildOffsetContour(shapeAnalysis.sampled, innerOffset, shapeAnalysis.centerX, shapeAnalysis.centerY);

      if (mode === 'bordur') {
        targetCtx.strokeStyle = hasRealSource ? 'rgba(0,0,0,0.08)' : 'rgba(0,0,0,0.10)';
        targetCtx.lineWidth = Math.max(hasRealSource ? 2 : 3, edgeDepth * (hasRealSource ? 0.07 : 0.09));
        targetCtx.shadowColor = 'rgba(0,0,0,0)';
        targetCtx.shadowBlur = 0;
        strokeContour(targetCtx, innerContour);

        targetCtx.shadowColor = 'rgba(0,0,0,0)';
        targetCtx.shadowBlur = 0;
        targetCtx.strokeStyle = hasRealSource ? 'rgba(74,77,81,0.60)' : 'rgba(74,77,81,0.72)';
        targetCtx.lineWidth = Math.max(1, edgeDepth * (hasRealSource ? 0.018 : 0.024));
        strokeContour(targetCtx, innerContour);
      } else {
        targetCtx.strokeStyle = hasRealSource ? 'rgba(0,0,0,0.04)' : 'rgba(0,0,0,0.08)';
        targetCtx.lineWidth = Math.max(1, edgeDepth * (hasRealSource ? 0.05 : 0.10));
        targetCtx.shadowColor = 'rgba(0,0,0,0)';
        targetCtx.shadowBlur = 0;
        strokeContour(targetCtx, innerContour);
        targetCtx.shadowColor = 'rgba(0,0,0,0)';
        targetCtx.shadowBlur = 0;
      }

      if (!hasRealSource || mode === 'bordur') {
        targetCtx.strokeStyle = hasRealSource
          ? 'rgba(95,95,95,0.08)'
          : (mode === 'bordur' ? 'rgba(95,95,95,0.20)' : 'rgba(110,110,110,0.16)');
        targetCtx.lineWidth = 1;
        traceBezierPath(targetCtx, shapeAnalysis.pts);
        targetCtx.stroke();
      }
    }

    targetCtx.restore();
  }


  // ── renderSacakBandLayer ─────────────────────────────────────────────────────
  // Oval/daire çevresine ürün fotoğrafındaki saçak dokusunu radyal olarak uygular.
  // productAnalysis.pixels'tan üst/alt fringe zone'u örnekler; outerDist BFS ile
  // sınırdan dışa doğru mesafe hesaplar. Her piksel için açı → arc kolon, od → derinlik.
  function renderSacakBandLayer(productAnalysis, shapeAnalysis, biyeDepth) {
      if (!productAnalysis || !shapeAnalysis) return null;
      var w = shapeAnalysis.width;
      var h = shapeAnalysis.height;
      var mask = shapeAnalysis.mask;
      var bounds = shapeAnalysis.bounds || { top: 0, bottom: h, left: 0, right: w };
      var cx = shapeAnalysis.centerX != null ? shapeAnalysis.centerX : (bounds.left + bounds.right) / 2;
      var cy = shapeAnalysis.centerY != null ? shapeAnalysis.centerY : (bounds.top + bounds.bottom) / 2;
      var srcPx = productAnalysis.pixels;
      var pBounds = productAnalysis.bounds || { top: 0, bottom: h, left: 0, right: w };

      var _sacakQc = (window.__OZEL_OLCU_CONFIG__ && window.__OZEL_OLCU_CONFIG__.qualityCode || '').toLowerCase();
      var _sacakMult = 1.4;
      if (_sacakQc.indexOf('jakarta') >= 0)  _sacakMult = 2.6;
      else if (_sacakQc.indexOf('puffy') >= 0)   _sacakMult = 2.2;
      else if (_sacakQc.indexOf('opera') >= 0)   _sacakMult = 2.0;
      else if (_sacakQc.indexOf('record') >= 0)  _sacakMult = 1.8;
      else if (_sacakQc.indexOf('garda') >= 0)   _sacakMult = 1.6;
      else if (_sacakQc.indexOf('bohem') >= 0)   _sacakMult = 2.0;
      else if (_sacakQc.indexOf('monza') >= 0)   _sacakMult = 2.2;
      var sacakLen = Math.round(biyeDepth * _sacakMult);
      sacakLen = Math.max(12, Math.min(sacakLen, Math.round(Math.min(w, h) * 0.055)));

      if (pBounds.top < sacakLen * 0.5 && pBounds.bottom > pBounds.top + sacakLen * 2) {
        pBounds = { left: pBounds.left, right: pBounds.right, top: sacakLen, bottom: pBounds.bottom };
      }
      console.log('[SacakMotor] v4.1 pTop=' + pBounds.top + ' pBot=' + pBounds.bottom + ' sacakLen=' + sacakLen);

      // BFS: şekil maskından dışa mesafe haritası
      var outerDist = new Int16Array(w * h);
      var seedX = new Int16Array(w * h);
      var seedY = new Int16Array(w * h);
      for (var fi = 0; fi < w * h; fi++) outerDist[fi] = -1;
      var bfsQ = [];
      for (var si = 0; si < w * h; si++) {
        if (!mask[si]) continue;
        var six = si % w, siy = (si / w) | 0;
        for (var dy = -1; dy <= 1; dy++) {
          for (var dx = -1; dx <= 1; dx++) {
            if (!dx && !dy) continue;
            var nx2 = six + dx, ny2 = siy + dy;
            if (nx2 < 0 || nx2 >= w || ny2 < 0 || ny2 >= h) continue;
            var ni = ny2 * w + nx2;
            if (mask[ni] || outerDist[ni] >= 0) continue;
            outerDist[ni] = 1; seedX[ni] = six; seedY[ni] = siy; bfsQ.push(ni);
          }
        }
      }
      for (var head = 0; head < bfsQ.length; head++) {
        var ci = bfsQ[head], cd = outerDist[ci];
        if (cd >= sacakLen) continue;
        var cxi = ci % w, cyi = (ci / w) | 0, csx = seedX[ci], csy = seedY[ci];
        for (var dy2 = -1; dy2 <= 1; dy2++) {
          for (var dx2 = -1; dx2 <= 1; dx2++) {
            if (!dx2 && !dy2) continue;
            var nnx = cxi + dx2, nny = cyi + dy2;
            if (nnx < 0 || nnx >= w || nny < 0 || nny >= h) continue;
            var nni = nny * w + nnx;
            if (mask[nni] || outerDist[nni] >= 0) continue;
            outerDist[nni] = cd + 1; seedX[nni] = csx; seedY[nni] = csy; bfsQ.push(nni);
          }
        }
      }

      var shapeW = Math.max(1, bounds.right - bounds.left);
      var shapeH = Math.max(1, bounds.bottom - bounds.top);
      var carpetW = Math.max(1, pBounds.right - pBounds.left);
      var carpetH = Math.max(1, pBounds.bottom - pBounds.top);
      var ARC_HALF = 1.1;

      var sacakCanvas = document.createElement('canvas');
      sacakCanvas.width = w; sacakCanvas.height = h;
      var sacakCtx = sacakCanvas.getContext('2d');
      var imgData = sacakCtx.createImageData(w, h);
      var sPx = imgData.data;
      var drawnPx = 0;

      for (var py = 0; py < h; py++) {
        for (var px = 0; px < w; px++) {
          var idx = py * w + px;
          var od = outerDist[idx];
          if (od < 1 || od > sacakLen || mask[idx]) continue;

          var bxs = seedX[idx], bys = seedY[idx];

          var isTop = bys < cy;
          var srcX = Math.round(pBounds.left + (bxs - bounds.left) / shapeW * carpetW);
          srcX = Math.max(pBounds.left, Math.min(pBounds.right - 1, srcX));

          var progress = od / sacakLen;
          var isTop = bys < cy;
          var srcY = isTop ? (pBounds.top + od) : (pBounds.bottom - od);
          srcY = Math.max(0, Math.min(h - 1, srcY));
          var spi = (srcY * w + srcX) * 4;
          var r = srcPx[spi], g = srcPx[spi + 1], b = srcPx[spi + 2];
          var tipFade = Math.max(0, 1.0 - progress * 0.35);
          var alpha = Math.round(250 * tipFade);
          if (alpha < 5) continue;

          sPx[idx * 4]     = r;
          sPx[idx * 4 + 1] = g;
          sPx[idx * 4 + 2] = b;
          sPx[idx * 4 + 3] = alpha;
          drawnPx++;
        }
      }

      console.log('[SacakMotor] v4.1 tamam: ' + drawnPx + ' piksel');
      sacakCtx.putImageData(imgData, 0, 0);
      return sacakCanvas;
    }
  function renderPreview(fabricImg, targetCanvas, productImg) {
    if (!targetCanvas) return;
    var tctx = targetCanvas.getContext('2d');
    var tw = targetCanvas.width;
    var th = targetCanvas.height;
    var productAnalysis = analyzeProductPreview(productImg || targetCanvas, tw, th);
    var layout = resolveRenderLayout(tw, th, productAnalysis);
    var shapeAnalysis = buildShapeAnalysis(tw, th, layout);
    var fabricKey = String(fabricImg && (fabricImg.currentSrc || fabricImg.src || 'fabric') || 'fabric');
    var fabricAnalysis = fabricImg
      ? analyzeFabricMaterial(fabricImg, fabricKey + '|' + edgeType, edgeType === 'bordur' ? 'bordur' : 'biye')
      : {
          baseColor: { r: 200, g: 200, b: 200 },
          baseLum: 200,
          detailLumBase: 200,
          lowPixels: new Uint8ClampedArray([200, 200, 200, 255]),
          lowW: 1,
          lowH: 1,
          detailPixels: new Uint8ClampedArray([200, 200, 200, 255]),
          detailW: 1,
          detailH: 1,
          repeatU: 1,
          repeatV: 1
        };
    var swatch = fabricAnalysis.baseColor;
    var baseCanvas;
    var edgeCanvas = null;
    var currentProductSrc = productImg ? String(productImg.currentSrc || productImg.src || '') : '';
    var biyeDepth = getScaledEdgeDepth(tw, productImg, 'biye', layout.sw);
    var bordurDepth = getScaledEdgeDepth(tw, productImg, 'bordur', layout.sw);
    var overlokDepth = getScaledEdgeDepth(tw, productImg, 'overlok', layout.sw);
    var edgeDepth = edgeType === 'bordur' ? bordurDepth : edgeType === 'overlok' ? overlokDepth : biyeDepth;
    console.log('[AmorfPreview] edgeType=' + edgeType + ' depth=' + edgeDepth + 'px, layout.sw=' + Math.round(layout.sw) + 'px, widthCm=' + widthCm + ', pxPerCm=' + (layout.sw/widthCm).toFixed(2));
    var hasRealSource = false;

    if (edgeType === 'overlok') {
      // Overlok: stitch efekti ile temiz kenar
      baseCanvas = renderOverlokShape(productAnalysis, shapeAnalysis, swatch, overlokDepth);
    } else if (edgeType === 'sacak') {
      // Saçak: oval/daire çevresine ürün fotoğrafındaki saçak dokusu giydirme
      baseCanvas = renderInteriorShape(productAnalysis, shapeAnalysis, 0);
      edgeCanvas = renderSacakBandLayer(productAnalysis, shapeAnalysis, biyeDepth);
    } else {
      // Biye / Bordür: renkli kenar bandı
      baseCanvas = renderInteriorShape(productAnalysis, shapeAnalysis, edgeDepth);
      edgeCanvas = renderEdgeBandLayer(
        productAnalysis,
        shapeAnalysis,
        fabricAnalysis,
        edgeDepth,
        edgeType === 'bordur' ? 'bordur' : 'biye',
        currentProductSrc,
        true
      );
    }

    var postCanvas = document.createElement('canvas');
    postCanvas.width = tw;
    postCanvas.height = th;
    var postCtx = postCanvas.getContext('2d');
    if (edgeType === 'overlok') {
      postCtx.filter = 'contrast(' + PREVIEW_POST_CONTRAST + ') saturate(' + PREVIEW_POST_SATURATE + ')';
    } else {
      postCtx.filter = 'contrast(' + PREVIEW_POST_CONTRAST + ') saturate(1.02)';
    }
    postCtx.drawImage(baseCanvas, 0, 0);
    postCtx.filter = 'none';

    tctx.clearRect(0, 0, tw, th);
    // Canvas ŞEFFAF kalır (PNG alpha) — şeklin dışı transparent, galeri CSS bg'si (#f7f4ee)
    // arkadan görünür. Hafif drop shadow ile şekil kenarı bg'ye bakılmaksızın belirgin.
    tctx.shadowColor = 'rgba(0,0,0,0.10)';
    tctx.shadowBlur = 14;
    tctx.shadowOffsetX = 0;
    tctx.shadowOffsetY = 4;
    tctx.drawImage(postCanvas, 0, 0);
    tctx.shadowColor = 'transparent';
    tctx.shadowBlur = 0;
    tctx.shadowOffsetY = 0;
    if (edgeCanvas) tctx.drawImage(edgeCanvas, 0, 0);
    if (edgeType === 'overlok') {
      applyContourFinishing(
        tctx,
        shapeAnalysis,
        edgeDepth,
        edgeType,
        swatch,
        hasRealSource
      );
    }

    // v4.0 — Hotspot (2) dinamik yerlesimi icin GERCEK target canvas bbox'ini cache'le.
    // shapeAnalysis.bounds pixel-exact mask tabanli (target canvas'ta amorfun gercek sinirlari).
    // shapeAnalysis.sampled absolute target canvas koordinatlari (upper-right anchor icin).
    try {
      var _sArr = shapeAnalysis && shapeAnalysis.sampled ? shapeAnalysis.sampled : null;
      var _sBounds = shapeAnalysis && shapeAnalysis.bounds ? shapeAnalysis.bounds : null;
      if (_sArr && _sArr.length && _sBounds) {
        var _bbH = (_sBounds.bottom - _sBounds.top) || 1;
        var _yLo = _sBounds.top + _bbH * 0.15;
        var _yHi = _sBounds.top + _bbH * 0.45;
        var _bestX = -Infinity, _bestY = _sBounds.top;
        for (var _ri = 0; _ri < _sArr.length; _ri++) {
          var _sp = _sArr[_ri];
          if (_sp.y >= _yLo && _sp.y <= _yHi && _sp.x > _bestX) {
            _bestX = _sp.x; _bestY = _sp.y;
          }
        }
        if (_bestX === -Infinity) { _bestX = _sBounds.right; _bestY = (_sBounds.top+_sBounds.bottom)/2; }
        _lastRenderBounds = {
          w: tw, h: th,
          bounds: {
            left: _sBounds.left, top: _sBounds.top,
            right: _sBounds.right, bottom: _sBounds.bottom
          },
          rightAnchor: { x: _bestX/tw, y: _bestY/th },
          bbox: {
            xMin: _sBounds.left/tw, xMax: _sBounds.right/tw,
            yMin: _sBounds.top/th,  yMax: _sBounds.bottom/th
          },
          ts: Date.now()
        };
        // Gallery tarafi hotspot'u yeniden hesaplasin diye notify
        try { window.dispatchEvent(new CustomEvent('amorf:render-bounds-updated', { detail: _lastRenderBounds })); } catch(_ev) {}
      }
    } catch(_e) {}

    return targetCanvas;
  }

  // ═══ ETKİLEŞİM ═══

  function initInteraction() {
    if (!canvas) return;

    function mpos(e) {
      var r = canvas.getBoundingClientRect();
      return {x: (e.clientX-r.left)*(canvas.width/r.width), y: (e.clientY-r.top)*(canvas.height/r.height)};
    }

    function isNearEdge(mx, my) {
      var sz = getCanvasSize();
      var pts = getAllPoints(sz);
      for (var i = 0; i < pts.length; i++) {
        if (Math.sqrt((mx-pts[i].x)*(mx-pts[i].x)+(my-pts[i].y)*(my-pts[i].y)) < 20) return true;
      }
      return false;
    }

    canvas.addEventListener('mousedown', function(e) {
      var p = mpos(e);
      if (isNearEdge(p.x, p.y)) { isDragging = true; canvas.style.cursor = 'grabbing'; }
    });

    canvas.addEventListener('mousemove', function(e) {
      var p = mpos(e);
      if (isDragging) {
        var sz = getCanvasSize();
        var cx = sz.ox + sz.sw/2, cy = sz.oy + sz.sh/2;
        var angle = Math.atan2(p.y - cy, p.x - cx);
        var a = angle + Math.PI / 2;
        if (a < 0) a += Math.PI * 2;
        var idx = Math.round((a / (Math.PI * 2)) * N) % N;
        var dx = (p.x - cx) / (sz.sw / 2);
        var dy = (p.y - cy) / (sz.sh / 2);
        var newR = Math.max(MIN_R, Math.min(MAX_R, Math.sqrt(dx*dx + dy*dy)));
        for (var d = -DRAG_SPREAD; d <= DRAG_SPREAD; d++) {
          var ti = (idx + d + N) % N;
          var w = Math.exp(-(d*d) / (DRAG_SPREAD * 0.7));
          radii[ti] = radii[ti] * (1-w) + newR * w;
          radii[ti] = Math.max(MIN_R, Math.min(MAX_R, radii[ti]));
        }
        draw();
        fireChange();
        return;
      }
      canvas.style.cursor = isNearEdge(p.x, p.y) ? 'grab' : 'default';
    });

    canvas.addEventListener('mouseup', function() { isDragging = false; canvas.style.cursor = 'default'; });

    // Touch
    canvas.addEventListener('touchstart', function(e) {
      e.preventDefault();
      var t = e.touches[0], r = canvas.getBoundingClientRect();
      var p = {x:(t.clientX-r.left)*(canvas.width/r.width), y:(t.clientY-r.top)*(canvas.height/r.height)};
      if (isNearEdge(p.x, p.y)) isDragging = true;
    });
    canvas.addEventListener('touchmove', function(e) {
      e.preventDefault();
      if (!isDragging) return;
      var t = e.touches[0], r = canvas.getBoundingClientRect();
      var p = {x:(t.clientX-r.left)*(canvas.width/r.width), y:(t.clientY-r.top)*(canvas.height/r.height)};
      var sz = getCanvasSize();
      var cx = sz.ox+sz.sw/2, cy = sz.oy+sz.sh/2;
      var angle = Math.atan2(p.y-cy, p.x-cx);
      var a = angle+Math.PI/2; if(a<0)a+=Math.PI*2;
      var idx = Math.round((a/(Math.PI*2))*N) % N;
      var dx=(p.x-cx)/(sz.sw/2), dy=(p.y-cy)/(sz.sh/2);
      var newR = Math.max(MIN_R, Math.min(MAX_R, Math.sqrt(dx*dx+dy*dy)));
      for(var d=-DRAG_SPREAD;d<=DRAG_SPREAD;d++){var ti=(idx+d+N)%N;var w=Math.exp(-(d*d)/(DRAG_SPREAD*.7));radii[ti]=radii[ti]*(1-w)+newR*w;radii[ti]=Math.max(MIN_R,Math.min(MAX_R,radii[ti]));}
      draw(); fireChange();
    });
    canvas.addEventListener('touchend', function() { isDragging = false; });
  }

  function fireChange() {
    if (onChangeCallback) {
      var sz = getCanvasSize();
      var pts = getAllPoints(sz);
      var sampled = sampleBezier(pts);
      var m = calcMetrics(sampled, widthCm, lengthCm, sz.sw, sz.sh);
      // Sekil bounding box (amorf gercek olculeri) — SAMPLED BEZIER ile, PDF ile birebir eslesir
      // Backend PDF aynı sampled bezier bbox kullanıyor + safety scale 0.985 → frontend de aynı.
      var mnX=9999,mxX=-9999,mnY=9999,mxY=-9999;
      for(var di=0;di<sampled.length;di++){
        if(sampled[di].x<mnX)mnX=sampled[di].x;if(sampled[di].x>mxX)mxX=sampled[di].x;
        if(sampled[di].y<mnY)mnY=sampled[di].y;if(sampled[di].y>mxY)mxY=sampled[di].y;
      }
      // PDF tarafı kullandığı 0.985 safety scale'i burada da uygula — ekran + PDF aynı rakamı göstersin
      var _SAFETY_SCALE = 0.985;
      var shapeW = Math.round((mxX-mnX)/sz.sw*widthCm*_SAFETY_SCALE*10)/10;
      var shapeH = Math.round((mxY-mnY)/sz.sh*lengthCm*_SAFETY_SCALE*10)/10;
      var fireW=widthCm-shapeW, fireH=lengthCm-shapeH;
      var ruloArea=widthCm*lengthCm/10000; var firePct=Math.max(0,Math.round((1-m.areaM2/ruloArea)*100));
      onChangeCallback({
        radii: Array.prototype.slice.call(radii),
        areaM2: m.areaM2,
        perimeterM: m.perimeterM,
        widthCm: widthCm,
        lengthCm: lengthCm,
        shapeWidthCm: shapeW,
        shapeHeightCm: shapeH,
        fireWidthCm: fireW,
        fireHeightCm: fireH,
        firePercent: firePct,
        edgeType: edgeType,
        presetIdx: _lastPresetIdx, presetLabel: (_lastPresetIdx >= 0 && PRESETS[_lastPresetIdx]) ? PRESETS[_lastPresetIdx].l : null, presetGradient: (_lastPresetIdx >= 0 && PRESETS[_lastPresetIdx]) ? PRESETS[_lastPresetIdx].g : null, presetEdges: (_lastPresetIdx >= 0 && PRESETS[_lastPresetIdx] && PRESETS[_lastPresetIdx].e) ? PRESETS[_lastPresetIdx].e : null
      });
    }
  }

  // ═══ PRESET HTML ═══

  var _presetTag = 'genel';
  var _editorWasOpen = true; // Sekli Duzenle butonu AÇIK state'de gelir (FIX E2) - panel ise default KAPALI (Tasarim Editoru butonu ile acilir)
  function buildPresetHTML() {
    var html = '';
    html += '<div style="display:flex;gap:4px;margin-bottom:6px;">';
    var _ts = function(tag) { return 'flex:1;padding:5px 2px;border-radius:6px;border:1.5px solid '+(_presetTag===tag?'#e8622a':'#ddd')+';background:'+(_presetTag===tag?'#fff5f0':'#fff')+';color:'+(_presetTag===tag?'#e8622a':'#999')+';font-size:10px;font-weight:700;cursor:pointer;white-space:nowrap;'; };
    html += '<button type="button" class="ozel-olcu-amorf-tag" data-tag="genel" style="'+_ts('genel')+'">\u2726 T\u00fcm\u00fc</button>';
    html += '<button type="button" class="ozel-olcu-amorf-tag" data-tag="burc" style="'+_ts('burc')+'">\u2648 Bur\u00e7lar</button>';
    html += '<button type="button" class="ozel-olcu-amorf-tag" data-tag="popular" style="'+_ts('popular')+'">🔥 Trend</button>';
    html += '</div>';

    if (_presetTag === 'popular') {
      html += '<div id="amorf-popular-grid" style="max-height:300px;overflow-y:auto;border:1px solid #eee;border-radius:10px;padding:10px;background:#fafafa;text-align:center;">';
      html += '<div style="color:#bbb;font-size:12px;padding:20px 0;">\u23F3 Y\u00fckleniyor...</div>';
      html += '</div>';
      html += '<div style="height:4px;"></div>';
      return html;
    }

    var filtered = [];
    for (var fi = 0; fi < PRESETS.length; fi++) {
      if (_presetTag === 'burc') { if (PRESETS[fi].t === 'burc') filtered.push(fi); }
      else { if (PRESETS[fi].t !== 'burc') filtered.push(fi); }
    }
    // Tumu tabinda Kalp'i en basa pinle
    if (_presetTag !== 'burc') {
      for (var ki = 0; ki < filtered.length; ki++) {
        if (PRESETS[filtered[ki]].l === 'Kalp') {
          var kalpIdx = filtered.splice(ki, 1)[0];
          filtered.unshift(kalpIdx);
          break;
        }
      }
    }
    var cols = _presetTag === 'burc' ? 4 : 5;
    html += '<div style="max-height:300px;overflow-y:auto;border:1px solid #eee;border-radius:10px;padding:6px;background:#fafafa;">';
    html += '<div style="display:grid;grid-template-columns:repeat('+cols+',1fr);gap:4px;">';
    for (var gi = 0; gi < filtered.length; gi++) {
      var i = filtered[gi], p = PRESETS[i], r = p.r, pts = [];
      for (var j = 0; j < N; j++) { var a=(j/N)*Math.PI*2-Math.PI/2; pts.push({x:28+Math.cos(a)*r[j]*22,y:24+Math.sin(a)*r[j]*20}); }
      var svgD='M'+pts[0].x.toFixed(1)+','+pts[0].y.toFixed(1);
      for (var j=0;j<N;j++){var p0=pts[(j-1+N)%N],p1=pts[j],p2=pts[(j+1)%N],p3=pts[(j+2)%N];svgD+=' C'+(p1.x+TENSION*(p2.x-p0.x)).toFixed(1)+','+(p1.y+TENSION*(p2.y-p0.y)).toFixed(1)+' '+(p2.x-TENSION*(p3.x-p1.x)).toFixed(1)+','+(p2.y-TENSION*(p3.y-p1.y)).toFixed(1)+' '+p2.x.toFixed(1)+','+p2.y.toFixed(1);}
      svgD+='Z';
      var gc=p.g||['#e8622a','#c2410c'];
      html+='<div class="ozel-olcu-amorf-preset" data-preset="'+i+'" style="border:2px solid #eee;border-radius:8px;padding:3px 2px 2px;cursor:pointer;text-align:center;background:#fff;transition:.15s;position:relative;">';
      html+='<svg viewBox="0 0 56 48" width="56" height="48"><defs><linearGradient id="ag'+i+'" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stop-color="'+gc[0]+'"/><stop offset="100%" stop-color="'+gc[1]+'"/></linearGradient></defs><filter id="as'+i+'"><feDropShadow dx="1" dy="2" stdDeviation="1.5" flood-opacity="0.15"/></filter><path d="'+svgD+'" fill="url(#ag'+i+')" filter="url(#as'+i+')" stroke="rgba(0,0,0,0.1)" stroke-width="0.5"/></svg>';
      html+='<div style="font-size:8px;color:#888;line-height:1.1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">'+p.l+'</div>';
      if (p.t === 'burc') {
        // Burç presetine modern info butonu (SVG circle-i — uyarı değil, bilgi)
        var _bk = p.l.split(' ')[0];
        html+='<button type="button" class="ozel-olcu-amorf-preset-info" data-burc="'+_bk+'" aria-label="Bilgi" style="position:absolute;top:-5px;right:-5px;width:18px;height:18px;border-radius:50%;background:#fff;color:#888;border:1px solid #e5e5e5;cursor:pointer;padding:0;display:flex;align-items:center;justify-content:center;box-shadow:0 1px 3px rgba(0,0,0,0.08);z-index:2;"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg></button>';
      }
      {var _pe=(_presetEdges&&_presetEdges[String(i)])||(p.e||{o:1,b:1,d:1});html+='<div class="ape-dots" style="display:flex;gap:2px;justify-content:center;margin-top:1px;">';if(_pe.o!==false)html+='<span style="width:6px;height:6px;border-radius:50%;background:#2ecc71;display:inline-block;" title="Overlok"></span>';if(_pe.b!==false)html+='<span style="width:6px;height:6px;border-radius:50%;background:#3498db;display:inline-block;" title="Biye"></span>';if(_pe.d!==false)html+='<span style="width:6px;height:6px;border-radius:50%;background:#e67e22;display:inline-block;" title="Bord\u00fcr"></span>';html+='</div>';}
      html+='</div>';
    }
    html+='</div></div>';
    html+='<div style="display:flex;gap:10px;justify-content:center;align-items:center;margin:6px 0 4px;padding:4px 0;font-size:10px;color:#999;">';
    html+='<span style="display:flex;align-items:center;gap:3px;"><span style="width:7px;height:7px;border-radius:50%;background:#2ecc71;display:inline-block;"></span> Overlok</span>';
    html+='<span style="display:flex;align-items:center;gap:3px;"><span style="width:7px;height:7px;border-radius:50%;background:#3498db;display:inline-block;"></span> Biye</span>';
    html+='<span style="display:flex;align-items:center;gap:3px;"><span style="width:7px;height:7px;border-radius:50%;background:#e67e22;display:inline-block;"></span> Bord\u00fcr</span>';
    html+='</div>';
    html+='<button type="button" class="ozel-olcu-amorf-random" style="width:100%;padding:9px;background:#e8622a;color:#fff;border:none;border-radius:6px;font-size:12px;font-weight:600;cursor:pointer;margin-bottom:6px;display:flex;align-items:center;justify-content:center;gap:6px;"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10"/><path d="M20.49 15a9 9 0 0 1-14.85 3.36L1 14"/></svg>Yeni \u015eekil</button>';
    return html;
  }
  // ═══ POPULAR / TREND TAB ═══

  function _popularSvg(presetIdx) {
    var p = PRESETS[presetIdx], r = p ? p.r : null;
    if (!r) return '';
    var pts = [];
    for (var j = 0; j < N; j++) { var a=(j/N)*Math.PI*2-Math.PI/2; pts.push({x:24+Math.cos(a)*r[j]*18,y:20+Math.sin(a)*r[j]*16}); }
    var svgD='M'+pts[0].x.toFixed(1)+','+pts[0].y.toFixed(1);
    for (var j=0;j<N;j++){var p0=pts[(j-1+N)%N],p1=pts[j],p2=pts[(j+1)%N],p3=pts[(j+2)%N];svgD+=' C'+(p1.x+TENSION*(p2.x-p0.x)).toFixed(1)+','+(p1.y+TENSION*(p2.y-p0.y)).toFixed(1)+' '+(p2.x-TENSION*(p3.x-p1.x)).toFixed(1)+','+(p2.y-TENSION*(p3.y-p1.y)).toFixed(1)+' '+p2.x.toFixed(1)+','+p2.y.toFixed(1);}
    svgD+='Z';
    var gc = p.g || ['#e8622a','#c2410c'];
    return '<svg viewBox="0 0 48 40" width="48" height="40" style="flex-shrink:0;"><defs><linearGradient id="pg'+presetIdx+'" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stop-color="'+gc[0]+'"/><stop offset="100%" stop-color="'+gc[1]+'"/></linearGradient></defs><path d="'+svgD+'" fill="url(#pg'+presetIdx+')" stroke="rgba(0,0,0,0.1)" stroke-width="0.5"/></svg>';
  }

  function renderPopularTab() {
    var grid = container.querySelector('#amorf-popular-grid');
    if (!grid) return;

    function doRender(items) {
      if (!items || !items.length) {
        grid.innerHTML = '<div style="padding:24px;text-align:center;color:#bbb;font-size:12px;">Henüz yeterli veri yok.<br>Şekil seçildiğinde liste oluşur.</div>';
        return;
      }
      var html = '';
      for (var k = 0; k < items.length; k++) {
        var it = items[k];
        var presetIdx = parseInt(it.id);
        var isNaN_idx = isNaN(presetIdx) || presetIdx < 0 || presetIdx >= PRESETS.length;
        if (isNaN_idx) continue;
        var svgHtml = _popularSvg(presetIdx);
        var deltaHtml = '';
        if (it.delta > 0) {
          deltaHtml = '<span style="background:#dcfce7;color:#16a34a;border-radius:4px;padding:1px 4px;font-size:9px;font-weight:700;">+'+it.delta+' ↑</span>';
        } else if (it.delta < 0) {
          deltaHtml = '<span style="background:#fef2f2;color:#dc2626;border-radius:4px;padding:1px 4px;font-size:9px;font-weight:700;">'+it.delta+' ↓</span>';
        } else {
          deltaHtml = '<span style="color:#d1d5db;font-size:9px;">—</span>';
        }
        var medal = k === 0 ? '🥇' : k === 1 ? '🥈' : k === 2 ? '🥉' : ('<span style="display:inline-block;width:16px;height:16px;border-radius:50%;background:#e5e7eb;color:#6b7280;font-size:9px;font-weight:700;line-height:16px;text-align:center;">'+(k+1)+'</span>');
        html += '<div class="ozel-olcu-amorf-preset" data-preset="'+presetIdx+'" style="display:flex;align-items:center;gap:8px;padding:6px 8px;border-radius:8px;border:2px solid #eee;background:#fff;cursor:pointer;margin-bottom:4px;transition:.15s;">';
        html += '<span style="flex-shrink:0;">'+medal+'</span>';
        html += svgHtml;
        html += '<div style="flex:1;min-width:0;">';
        html += '<div style="font-size:11px;font-weight:600;color:#333;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">'+it.label+'</div>';
        html += '</div>';
        html += '<div style="text-align:right;flex-shrink:0;">'+deltaHtml+'</div>';
        html += '</div>';
      }
      grid.innerHTML = html;
      var cells = grid.querySelectorAll('.ozel-olcu-amorf-preset');
      for (var ci = 0; ci < cells.length; ci++) {
        cells[ci].addEventListener('click', (function(cell) { return function() {
          var idx = parseInt(cell.getAttribute('data-preset'));
          radii = new Float64Array(PRESETS[idx].r);
          normalizeRadiiToFill(0.96);
          _lastPresetIdx = idx;
          _applyPresetEdge(idx);
          grid.querySelectorAll('.ozel-olcu-amorf-preset').forEach(function(el) { el.style.borderColor = '#eee'; });
          cell.style.borderColor = '#e8622a';
          draw();
          fireChange();
          _postShapePick(idx);
        }; })(cells[ci]));
      }
    }

    var now = Date.now();
    if (_popularCache && (now - _popularCache.fetchedAt) < 30000) {
      doRender(_popularCache.items);
      return;
    }
    grid.innerHTML = '<div style="padding:24px;text-align:center;color:#bbb;font-size:12px;">⏳ Yükleniyor...</div>';
    fetch(_POPULAR_BASE + '/shape-top?limit=10')
      .then(function(r) { return r.json(); })
      .then(function(d) {
        if (d.ok) {
          _popularCache = { items: d.items, fetchedAt: Date.now() };
          doRender(d.items);
        } else {
          grid.innerHTML = '<div style="padding:16px;color:#f87171;font-size:11px;">Yüklenemedi: ' + (d.error || '?') + '</div>';
        }
      })
      .catch(function(e) {
        grid.innerHTML = '<div style="padding:16px;color:#f87171;font-size:11px;">Bağlantı hatası.</div>';
      });
  }

  function _showAspectSuggestion(presetIdx) {
    try {
      var p = PRESETS[presetIdx];
      if (!p) return;
      var idealAspect = _PRESET_ASPECT[p.l];
      if (!idealAspect) return;
      var enInput = document.getElementById('ozel-olcu-width');
      var boyInput = document.getElementById('ozel-olcu-length');
      if (!enInput || !boyInput) return;
      var curEn = parseInt(enInput.value, 10) || 0;
      var curBoy = parseInt(boyInput.value, 10) || 0;
      if (curEn < 10 || curBoy < 10) return;
      var curAspect = curEn / curBoy;
      var diff = Math.abs(curAspect - idealAspect) / idealAspect;
      var banner = document.getElementById('amorf-aspect-suggestion');
      if (!banner) return;
      if (diff <= 0.05) { banner.style.display = 'none'; return; }
      var idealBoy = Math.round(curEn / idealAspect);
      // Min 30, max 400 sinir kontrolu (Shopify ozel olcu limit)
      if (idealBoy < 30 || idealBoy > 400) { banner.style.display = 'none'; return; }
      var txt = banner.querySelector('#amorf-aspect-text');
      var btn = banner.querySelector('#amorf-apply-aspect');
      if (txt) txt.innerHTML = '\uD83D\uDCA1 <b>' + p.l + '</b> i\u00e7in en uygun \u00f6l\u00e7\u00fc: <b>' + curEn + ' \u00d7 ' + idealBoy + ' cm</b> (\u015fu an: ' + curEn + '\u00d7' + curBoy + ')';
      if (btn) {
        btn.setAttribute('data-en', curEn);
        btn.setAttribute('data-boy', idealBoy);
      }
      banner.style.display = 'flex';
    } catch(e) { console.warn('[Amorf] aspect suggestion error:', e); }
  }

  function _applyAspectSuggestion() {
    try {
      var btn = document.getElementById('amorf-apply-aspect');
      if (!btn) return;
      var en = parseInt(btn.getAttribute('data-en'), 10);
      var boy = parseInt(btn.getAttribute('data-boy'), 10);
      var enInput = document.getElementById('ozel-olcu-width');
      var boyInput = document.getElementById('ozel-olcu-length');
      if (enInput && en) {
        enInput.value = en;
        enInput.dispatchEvent(new Event('input', { bubbles: true }));
        enInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (boyInput && boy) {
        boyInput.value = boy;
        boyInput.dispatchEvent(new Event('input', { bubbles: true }));
        boyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var banner = document.getElementById('amorf-aspect-suggestion');
      if (banner) banner.style.display = 'none';
    } catch(e) { console.warn('[Amorf] apply aspect error:', e); }
  }

  function _postShapePick(presetIdx) {
    try {
      _showAspectSuggestion(presetIdx);
      var p = PRESETS[presetIdx];
      if (!p) return;
      _popularCache = null;
      fetch(_POPULAR_BASE + '/shape-pick', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ shapeId: String(presetIdx), label: p.l, category: p.t || 'amorf' })
      }).catch(function(){});
    } catch(e) {}
  }

  // ═══ PUBLIC API ═══

  function init(containerEl, config) {
    container = containerEl;
    if (config) {
      if (config.widthCm) widthCm = config.widthCm;
      if (config.lengthCm) lengthCm = config.lengthCm;
      if (config.edgeType) edgeType = config.edgeType;
      if (config.onChange) onChangeCallback = config.onChange;
    }

    // Canvas oluştur
    var ratio = widthCm / lengthCm;
    var maxW = 400, maxH = 400;
    var cvW, cvH;
    if (ratio >= 1) { cvW = maxW; cvH = Math.max(150, Math.round(maxW / ratio)); }
    else { cvH = maxH; cvW = Math.max(150, Math.round(maxH * ratio)); }

    container.innerHTML = buildPresetHTML() +
      '<canvas id="ozel-olcu-amorf-canvas" width="'+cvW+'" height="'+cvH+'" style="display:block;width:100%;max-width:'+cvW+'px;border-radius:8px;border:1px solid #eee;cursor:default;"></canvas>' +
      '<div style="display:flex;justify-content:space-around;font-size:11px;color:#999;padding:6px 0;">' +
        '<span>Alan: <b id="ozel-olcu-amorf-area" style="color:#e8622a;">—</b></span>' +
        '<span>Çevre: <b id="ozel-olcu-amorf-perim" style="color:#e8622a;">—</b></span>' +
      '</div>';

    _wrapEditorUI();
    canvas = document.getElementById('ozel-olcu-amorf-canvas');
    ctx = canvas.getContext('2d');

    // Preset tıklama
    var presetEls = container.querySelectorAll('.ozel-olcu-amorf-preset');
    for (var i = 0; i < presetEls.length; i++) {
      presetEls[i].addEventListener('click', function(e) {
        // Info ikonu tıklanmışsa preset seçme, info event dispatch et
        if (e.target.closest('.ozel-olcu-amorf-preset-info')) {
          e.preventDefault(); e.stopPropagation();
          var burc = e.target.closest('.ozel-olcu-amorf-preset-info').getAttribute('data-burc');
          window.dispatchEvent(new CustomEvent('amorf:burc-info', { detail: { burc: burc } }));
          return;
        }
        var idx = parseInt(this.getAttribute('data-preset'));
        radii = new Float64Array(PRESETS[idx].r); normalizeRadiiToFill(0.96); _lastPresetIdx = idx; _applyPresetEdge(idx);
        // Aktif preset vurgula
        presetEls.forEach(function(el) { el.style.borderColor = '#eee'; });
        this.style.borderColor = '#e8622a';
        draw();
        fireChange();
        _postShapePick(idx);
      });
    }

    
    // Tag toggle
    var tagBtns = container.querySelectorAll('.ozel-olcu-amorf-tag');
    for (var ti = 0; ti < tagBtns.length; ti++) {
      tagBtns[ti].addEventListener('click', function() {
        _presetTag = this.getAttribute('data-tag');
        var _p = document.getElementById('amorf-editor-panel');
        _editorWasOpen = _p && _p.style.display !== 'none';
        var cvW = canvas.width, cvH = canvas.height;
        container.innerHTML = buildPresetHTML() +
          '<canvas id="ozel-olcu-amorf-canvas" width="'+cvW+'" height="'+cvH+'" style="display:block;width:100%;max-width:'+cvW+'px;border-radius:8px;border:1px solid #eee;cursor:default;"></canvas>' +
          '<div style="display:flex;justify-content:space-around;font-size:11px;color:#999;padding:6px 0;"><span>Alan: <b id="ozel-olcu-amorf-area" style="color:#e8622a;">\u2014</b></span><span>\u00c7evre: <b id="ozel-olcu-amorf-perim" style="color:#e8622a;">\u2014</b></span></div>';
        _wrapEditorUI();
        canvas = document.getElementById('ozel-olcu-amorf-canvas');
        ctx = canvas.getContext('2d');
        rebindAll();
        if (_presetTag === 'popular') renderPopularTab();
      });
    }

    function rebindAll() {
      var pp = container.querySelectorAll('.ozel-olcu-amorf-preset');
      for (var pi2 = 0; pi2 < pp.length; pi2++) {
        pp[pi2].addEventListener('click', function(e) {
          if (e.target.closest('.ozel-olcu-amorf-preset-info')) {
            e.preventDefault(); e.stopPropagation();
            var burc = e.target.closest('.ozel-olcu-amorf-preset-info').getAttribute('data-burc');
            window.dispatchEvent(new CustomEvent('amorf:burc-info', { detail: { burc: burc } }));
            return;
          }
          var idx = parseInt(this.getAttribute('data-preset'));
          radii = new Float64Array(PRESETS[idx].r); normalizeRadiiToFill(0.96); _lastPresetIdx = idx; _applyPresetEdge(idx);
          pp.forEach(function(el) { el.style.borderColor = '#eee'; });
          this.style.borderColor = '#e8622a';
          draw(); fireChange();
          _postShapePick(idx);
        });
      }
      var tb2 = container.querySelectorAll('.ozel-olcu-amorf-tag');
      for (var ti2 = 0; ti2 < tb2.length; ti2++) {
        tb2[ti2].addEventListener('click', function() {
          _presetTag = this.getAttribute('data-tag');
          var _p2 = document.getElementById('amorf-editor-panel');
          _editorWasOpen = _p2 && _p2.style.display !== 'none';
          var cvW = canvas.width, cvH = canvas.height;
          container.innerHTML = buildPresetHTML() +
            '<canvas id="ozel-olcu-amorf-canvas" width="'+cvW+'" height="'+cvH+'" style="display:block;width:100%;max-width:'+cvW+'px;border-radius:8px;border:1px solid #eee;cursor:default;"></canvas>' +
            '<div style="display:flex;justify-content:space-around;font-size:11px;color:#999;padding:6px 0;"><span>Alan: <b id="ozel-olcu-amorf-area" style="color:#e8622a;">\u2014</b></span><span>\u00c7evre: <b id="ozel-olcu-amorf-perim" style="color:#e8622a;">\u2014</b></span></div>';
          _wrapEditorUI();
          canvas = document.getElementById('ozel-olcu-amorf-canvas');
          ctx = canvas.getContext('2d');
          rebindAll();
          initInteraction();
          draw();
          if (_presetTag === 'popular') renderPopularTab();
        });
      }
      var rb = container.querySelector('.ozel-olcu-amorf-random');
      if (rb) rb.addEventListener('click', function() { randomShape(); });
      initInteraction();
      draw();
    }

    // Random buton
    var rndBtn = container.querySelector('.ozel-olcu-amorf-random');
    if (rndBtn) rndBtn.addEventListener('click', function() { randomShape(); });

    // Varsayılan şekil yükle
    radii = new Float64Array(PRESETS[0].r);
    _lastPresetIdx = 0; _applyPresetEdge(0);
    initInteraction();
    _fetchPresetEdges();
    draw();
    fireChange();
  }

  function setDimensions(wCm, hCm) {
    widthCm = wCm;
    lengthCm = hCm;
    // Canvas oranını güncelle
    if (canvas) {
      var ratio = wCm / hCm;
      var maxW = 400, maxH = 400;
      if (ratio >= 1) { canvas.width = maxW; canvas.height = Math.max(150, Math.round(maxW / ratio)); }
      else { canvas.height = maxH; canvas.width = Math.max(150, Math.round(maxH * ratio)); }
      canvas.style.maxWidth = canvas.width + 'px';
    }
    draw();
    fireChange();
  }

  function setEdgeType(type) {
    edgeType = type;
    draw();
    fireChange();
  }

  function selectPresetByName(name) {
    if (name === 'Daire' || name === 'Oval') {
      radii = makeUniformShape(0.96);
      draw();
      fireChange();
      return;
    }
    for (var i = 0; i < PRESETS.length; i++) {
      if (PRESETS[i].l === name) {
        radii = new Float64Array(PRESETS[i].r);
        draw();
        fireChange();
        return;
      }
    }
  }

  function getShape() {
    var sz = getCanvasSize();
    var pts = getAllPoints(sz);
    var sampled = sampleBezier(pts);
    var m = calcMetrics(sampled, widthCm, lengthCm, sz.sw, sz.sh);

    // Normalize 0-1
    var xs = [], ys = [];
    for (var i = 0; i < pts.length; i++) { xs.push(pts[i].x); ys.push(pts[i].y); }
    var minX = Math.min.apply(null, xs), maxX = Math.max.apply(null, xs);
    var minY = Math.min.apply(null, ys), maxY = Math.max.apply(null, ys);
    var w = maxX - minX || 1, h = maxY - minY || 1;
    var contour = [];
    for (var j = 0; j < pts.length; j++) {
      contour.push([(pts[j].x - minX) / w, (pts[j].y - minY) / h]);
    }

    // v4.0 — hotspot dinamik yerlesimi icin GERCEK kenar verisi (canvas 0-1 normalize).
    // sampled bezier bbox = amorfun canvasta kapladigi gercek dis sinir.
    // "rightAnchor" = sag yarimkurede y in [0.15, 0.45] araligindaki en sag nokta —
    // uc hotspot'u burada cizerek dot halinin ust-sag dis kenarina oturur.
    var _sMnX=Infinity,_sMxX=-Infinity,_sMnY=Infinity,_sMxY=-Infinity;
    for (var _si=0;_si<sampled.length;_si++){
      var _sp=sampled[_si];
      if(_sp.x<_sMnX)_sMnX=_sp.x; if(_sp.x>_sMxX)_sMxX=_sp.x;
      if(_sp.y<_sMnY)_sMnY=_sp.y; if(_sp.y>_sMxY)_sMxY=_sp.y;
    }
    var _cw=sz.w||1,_ch=sz.h||1;
    var sampledBbox = {
      xMin: _sMnX/_cw, xMax: _sMxX/_cw,
      yMin: _sMnY/_ch, yMax: _sMxY/_ch
    };
    // Upper-right region anchor: y_norm in [0.15,0.45] icinde en sag x
    var _bbH = (_sMxY - _sMnY) || 1;
    var _yLoAbs = _sMnY + _bbH * 0.15;
    var _yHiAbs = _sMnY + _bbH * 0.45;
    var _bestX = -Infinity, _bestY = _sMnY;
    for (var _ai=0;_ai<sampled.length;_ai++){
      var _ap=sampled[_ai];
      if (_ap.y >= _yLoAbs && _ap.y <= _yHiAbs && _ap.x > _bestX){
        _bestX = _ap.x; _bestY = _ap.y;
      }
    }
    if (_bestX === -Infinity) { _bestX = _sMxX; _bestY = (_sMnY+_sMxY)/2; }
    var rightAnchor = { x: _bestX/_cw, y: _bestY/_ch };

    // v4.0 — Eger gallery target canvas'inda gercek render yapilmissa (renderPreview sonrasi),
    // onun bbox'ini oncelikle kullan (productAnalysis layout editor canvas'tan farkli olabilir).
    var _srcTag = 'editor';
    if (_lastRenderBounds && _lastRenderBounds.rightAnchor) {
      rightAnchor = _lastRenderBounds.rightAnchor;
      sampledBbox = _lastRenderBounds.bbox || sampledBbox;
      _srcTag = 'render';
    }

    return {
      radii: Array.prototype.slice.call(radii),
      contour: contour,
      areaM2: m.areaM2,
      perimeterM: m.perimeterM,
      widthCm: widthCm,
      lengthCm: lengthCm,
      edgeType: edgeType,
      presetIdx: _lastPresetIdx,
      presetLabel: (_lastPresetIdx >= 0 && PRESETS[_lastPresetIdx]) ? PRESETS[_lastPresetIdx].l : null,
      canvasSize: _lastRenderBounds ? { w: _lastRenderBounds.w, h: _lastRenderBounds.h } : { w: _cw, h: _ch },
      sampledBbox: sampledBbox,
      rightAnchor: rightAnchor,
      anchorSource: _srcTag
    };
  }

  // Public API
  window.__OzelOlcuAmorf = {
    getPresetList: function() {
      var list = [];
      for (var i = 0; i < PRESETS.length; i++) {
        if (PRESETS[i].t === 'burc') continue;
        var p = PRESETS[i], pts = [], r = p.r;
        for (var j = 0; j < 60; j++) { var a=(j/60)*Math.PI*2-Math.PI/2; pts.push({x:14+Math.cos(a)*r[j]*11,y:12+Math.sin(a)*r[j]*10}); }
        var d='M'+pts[0].x.toFixed(1)+','+pts[0].y.toFixed(1);
        for(var j=0;j<60;j++){var p0=pts[(j-1+60)%60],p1=pts[j],p2=pts[(j+1)%60],p3=pts[(j+2)%60];d+=' C'+(p1.x+0.28*(p2.x-p0.x)).toFixed(1)+','+(p1.y+0.28*(p2.y-p0.y)).toFixed(1)+' '+(p2.x-0.28*(p3.x-p1.x)).toFixed(1)+','+(p2.y-0.28*(p3.y-p1.y)).toFixed(1)+' '+p2.x.toFixed(1)+','+p2.y.toFixed(1);}
        d+='Z';
        list.push({idx:i, label:p.l, g:p.g, svgPath:d});
      }
      return list;
    },
    init: init,
    setDimensions: setDimensions,
    setEdgeType: setEdgeType,
    selectPresetByName: selectPresetByName,
    getShape: getShape,
    randomShape: randomShape,
    selectRandomPreset: selectRandomPreset,
    closeEditor: closeEditor,
    openEditor: openEditor,
    renderPreview: renderPreview,
    refresh: function() { draw(); fireChange(); },
    loadPreset: function(idx) {
      if (PRESETS[idx]) {
        radii = new Float64Array(PRESETS[idx].r); normalizeRadiiToFill(0.96); _lastPresetIdx = idx; _applyPresetEdge(idx);
        draw();
        fireChange();
      }
    },
    setRadii: function(r) {
      if (!r || !r.length) return;
      radii = new Float64Array(r);
      normalizeRadiiToFill(0.96); // eski/restore radii'leri de bbox'ı doldurtmak için normalize
      draw();
      fireChange();
    }
  };

  console.log('[OzelOlcuAmorf] v2.0 yüklendi');
})();

// cache-bust: 2026-05-08T20:29:27.265582
